// Módulo: Formulário de Lançamentos
// Responsável por renderizar o formulário, gerenciar eventos de UI, itens dinâmicos e anexos.

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

Object.assign(window.FazendaRP.Pages.financeiro, {

    // Cache local de dependências (Helper)
    maquinasCache: [],
    safrasCache: [],
    contasData: [],
    planoContasData: [],
    SuprimentosData: [],
    _pendingCloneData: null, // State for Duplication
    _pendingEditId: null,

    // --- DUPLICATE / CLONE ---
    preencherFormulario: function (data) {
        console.log("Preparing to Clone:", data);
        this._pendingCloneData = data;
        this._pendingEditId = null;
        // Force Tab Switch
        this.renderTabContent('novo-lancamento');
        document.querySelectorAll('.submenu-item').forEach(t => t.classList.remove('active'));
        document.querySelector('.submenu-item[data-tab="novo-lancamento"]')?.classList.add('active');
    },

    // Helper para carregar dados de contas (assumindo que existe em outro lugar ou será adicionado)
    loadContasData: async function () {
        console.log("Financeiro: Carregando dados de contas...");
        const { data, error } = await window.FazendaRP.supabase
            .from('contas')
            .select('*')
            .order('nome');
        if (error) {
            console.error("Financeiro: Erro ao carregar contas:", error);
            this.contasData = [];
        } else {
            this.contasData = data || [];
            console.log(`Financeiro: ${this.contasData.length} contas carregadas.`);
        }
    },

    // Helper para carregar dados do plano de contas (assumindo que existe em outro lugar ou será adicionado)
    loadPlanoContasData: async function () {
        console.log("Financeiro: Carregando dados do plano de contas...");
        const { data, error } = await window.FazendaRP.supabase
            .from('plano_contas')
            .select('*')
            .order('codigo');
        if (error) {
            console.error("Financeiro: Erro ao carregar plano de contas:", error);
            this.planoContasData = [];
        } else {
            this.planoContasData = data || [];
            console.log(`Financeiro: ${this.planoContasData.length} itens do plano de contas carregados.`);
        }
    },

    // Helper para carregar dados de máquinas
    loadMaquinasData: async function () {
        console.log("Financeiro: Carregando dados de máquinas...");
        const { data: maquinas, error } = await window.FazendaRP.supabase
            .from('frota')
            .select('id, nome, placa, tipo, combustiveis')
            .order('nome');

        if (error) {
            console.error("Financeiro: Erro ao carregar máquinas:", error);
            this.maquinasCache = [];
        } else {
            this.maquinasCache = maquinas || [];
            console.log(`Financeiro: ${this.maquinasCache.length} máquinas carregadas.`);
        }
    },

    // Helper para carregar Safras
    loadSafrasData: async function () {
        console.log("Financeiro: Carregando dados de safras...");
        const { data, error } = await window.FazendaRP.supabase
            .from('safras')
            .select('id, descricao, ano, status') // Corrected columns based on relatorios.js
            .eq('status', 'Ativa')
            .order('ano', { ascending: false });

        if (error) {
            console.error("Financeiro: Erro ao carregar safras:", error);
            this.safrasCache = [];
        } else {
            this.safrasCache = data || [];
            console.log(`Financeiro: ${this.safrasCache.length} safras carregadas.`);
        }
    },

    getSafrasOptionsHTML: function () {
        return '<option value="">Selecione a Safra...</option>' +
            (this.safrasCache || []).map(s => `<option value="${s.id}">${s.descricao} (${s.ano})</option>`).join('');
    },

    renderFormularioLancamento: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Preparando formulário...</div>';

        try {
            // 1. Carregar Dependências
            if (!this.contasData || this.contasData.length === 0) await this.loadContasData();
            await this.loadPlanoContasData(); // Ensure Plano de Contas is loaded
            if (!this.maquinasCache || this.maquinasCache.length === 0) await this.loadMaquinasData(); // Load Machines

            // Load Suprimentos (Critical for Item Search)
            // FORCE RELOAD: Ensuring we have the latest schema (requires_machine)
            console.log("Financeiro: Carregando dados de suprimentos (Forced Fresh Load)...");
            window.FazendaRP.SuprimentosData = null;

            if (!window.FazendaRP.SuprimentosData || window.FazendaRP.SuprimentosData.length === 0) {
                const { data: supData, error: supErr } = await window.FazendaRP.supabase
                    .from('suprimentos_itens')
                    .select('*, requires_machine') // Explicitly requesting requires_machine
                    .neq('status', 'Inativo');

                if (supErr) {
                    console.error("Financeiro: Erro ao carregar suprimentos:", supErr);
                }

                if (supData) {
                    window.FazendaRP.SuprimentosData = supData.map(item => ({
                        id: item.id,
                        nome: item.nome,
                        tipo: item.tipo, // 'Material' or 'Group'
                        parentId: item.parent_id,
                        expanded: false,
                        unidades: item.unidades || [],
                        contas: item.contas || [],
                        requiresMachine: item.requires_machine // Mapped from DB
                    }));
                    console.log(`Financeiro: ${window.FazendaRP.SuprimentosData.length} itens de suprimentos carregados.`);
                } else {
                    console.warn("Financeiro: Nenhum item de suprimento encontrado.");
                }
            }

            const { data: parceiros, error: errParc } = await window.FazendaRP.supabase
                .from('parceiros')
                .select('id, nome, cpf_cnpj')
                .eq('status', 'Ativo')
                .order('nome');

            if (errParc) console.error("Erro carregando parceiros:", errParc);

            // Carregar Maquinas e Safras
            const { data: maquinas } = await window.FazendaRP.supabase.from('frota').select('id, nome, placa, tipo, combustiveis').order('nome');
            this.maquinasCache = maquinas || [];

            const { data: safrasData } = await window.FazendaRP.supabase.from('safras').select('*').order('ano', { ascending: false });
            this.safrasCache = safrasData || [];

            // 2. Renderizar Form HTML
            container.innerHTML = `
                <div class="card">
                     <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <!-- Input Items -->
                            <input type="file" id="import-xml-items-input" accept=".xml" style="display: none;">
                            <button type="button" id="btn-import-xml-items" class="btn" style="background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; border-radius: 6px; padding: 6px 12px; font-weight: 500; display: flex; align-items: center; gap: 6px; font-size: 0.85rem;" title="Importar XML em Modo Detalhado (Estoque)">
                                <i class="fas fa-cubes"></i> XML (Com Itens)
                            </button>

                            <!-- Input Simple -->
                            <input type="file" id="import-xml-simple-input" accept=".xml" style="display: none;">
                            <button type="button" id="btn-import-xml-simple" class="btn" style="background: #e0f2f1; color: #00695c; border: 1px solid #b2dfdb; border-radius: 6px; padding: 6px 12px; font-weight: 500; display: flex; align-items: center; gap: 6px; font-size: 0.85rem;" title="Importar XML em Modo Simples (Financeiro)">
                                <i class="fas fa-file-invoice-dollar"></i> XML (Sem Itens)
                            </button>
                        </div>
                        <h3 style="margin: 0;">Novo Lançamento</h3>
                    </div>

                </div>
                        <h3 style="margin: 0;">Novo Lançamento</h3>
                    </div>

                    <!-- CLIPBOARD PASTE BUTTON (IF EXISTS) -->
                    <div id="clipboard-area" style="display:none; background:#ecfdf5; border:1px dashed #10b981; padding:15px; margin-bottom:20px; border-radius:8px; align-items:center; gap:15px;">
                        <div style="font-size:1.5rem; color:#047857;"><i class="fas fa-clipboard-check"></i></div>
                        <div style="flex:1;">
                             <strong style="color:#065f46; display:block;">Dados Copiados Encontrados!</strong>
                             <span style="font-size:0.9rem; color:#064e3b;">Você copiou um lançamento recentemente. Deseja colar os dados aqui?</span>
                        </div>
                        <button type="button" id="btn-paste-clipboard" class="btn" style="background:#059669; color:white; font-weight:600; padding:8px 20px; border-radius:6px; border:none; display:flex; align-items:center; gap:8px;">
                            <i class="fas fa-paste"></i> Colar Dados
                        </button>
                         <button type="button" id="btn-clear-clipboard" class="btn" style="background:transparent; color:#6b7280; font-weight:500; padding:8px; border:none;" title="Descartar">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <!-- Magic Box Area -->
                    <div class="card" style="background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%); color: white; margin-bottom: 25px; padding: 20px; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(124, 58, 237, 0.3);">
                        <div style="display: flex; gap: 15px; align-items: flex-start;">
                            <div style="font-size: 1.5rem; color: #ddd6fe; padding-top: 5px;"><i class="fas fa-magic"></i></div>
                            <div style="flex: 1;">
                                <label style="font-weight: 600; font-size: 0.95rem; margin-bottom: 8px; display: block; color: white;">Lançamento Mágico (Beta)</label>
                                <textarea id="magic-input" rows="2" placeholder="Digite como se estivesse no WhatsApp: 'Gastei 1500 de diesel na S10 ontem'..." style="width: 100%; background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); color: white; padding: 12px; border-radius: 8px; font-size: 1rem; resize: none; outline: none; transition: all 0.2s;"></textarea>
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
                                    <span style="font-size: 0.8rem; opacity: 0.8;">Tente: "200 almoço", "5000 adubo milho"</span>
                                    <button type="button" id="btn-magic-process" style="background: white; color: #6d28d9; border: none; padding: 6px 16px; border-radius: 6px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 5px;">Processar <i class="fas fa-arrow-right"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <form id="form-lancamento">
                        <input type="hidden" id="edit-lanc-id">
                        
                        <div class="form-row">
                            <div class="form-group">
                                <label>Tipo Documento</label>
                                <select id="tipo-documento"><option>Nota Fiscal (NFe)</option><option>Recibo</option><option>Boleto</option><option>Outros</option></select>
                            </div>
                            <div class="form-group">
                                 <label>Nº Documento *</label>
                                 <input type="text" id="num-documento" placeholder="Ex: 12345">
                            </div>
                             <div class="form-group">
                                 <label>Data Emissão</label>
                                 <input type="date" id="data-emissao" value="${new Date().toISOString().split('T')[0]}">
                            </div>
                            <div class="form-group">
                                 <label>Valor Total (Nota) *</label>
                                 <input type="text" id="valor-total-nota" class="currency-mask" placeholder="R$ 0,00" style="font-weight: 600; color: #0f172a;">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label>Data de Vencimento</label>
                                <input type="date" id="data-vencimento" value="${new Date().toISOString().split('T')[0]}">
                            </div>
                            <div class="form-group" style="flex: 2;">
                                <label>Parceiro</label>
                                <div style="display: flex; gap: 5px;">
                                    <select style="flex: 1;" id="parceiro-select">
                                        <option value="">Selecione...</option>
                                        ${(parceiros || []).map(p => {
                const label = p.nome_fantasia && p.nome_fantasia !== p.nome
                    ? `${p.nome_fantasia} (${p.nome})`
                    : p.nome;
                return `<option value="${p.id}">${label} ${p.cpf_cnpj ? ' - ' + p.cpf_cnpj : ''}</option>`;
            }).join('')}
                                    </select>
                                    <button type="button" id="btn-add-novo-parceiro" class="btn" style="border: 1px solid #ddd;" title="Novo Parceiro">+</button>
                                </div>
                            </div>
                        </div>

                        <!-- Toggle Mode -->
                        <div style="margin: 20px 0; padding: 12px 15px; background: #f9fafb; border: 1px dashed #ddd; border-radius: 6px; display: flex; align-items: center; gap: 25px;">
                            <label style="font-weight: 500; margin: 0; white-space: nowrap;">Modo:</label>
                            <label style="cursor: pointer; display: flex; align-items: center; gap: 6px; margin: 0;">
                                <input type="radio" name="modo_lancamento" value="com_itens"> <span style="white-space: nowrap;">Com Itens (Estoque)</span>
                            </label>
                            <label style="cursor: pointer; display: flex; align-items: center; gap: 6px; margin: 0;">
                                <input type="radio" name="modo_lancamento" value="sem_itens" checked> <span style="white-space: nowrap;">Sem Itens (Simples)</span>
                            </label>
                        </div>

                        <div id="dynamic-area"></div>

                        <!-- Payment Section -->
                        <div class="form-section" style="margin-top: 25px;">
                            <h3 style="border-bottom: 1px solid #eee; padding-bottom: 10px; margin-bottom: 20px;">Pagamento</h3>
                            <div style="display: flex; gap: 30px; align-items: flex-start;">
                                <div style="flex: 1;">
                                    <div class="form-group"><label>Conta Saída / Banco</label><select id="conta-banco">${this.getContasOptionsHTML()}</select></div>
                                    <div class="form-group">
                                        <label>Forma de Pagamento</label>
                                        <select id="forma-pagamento">
                                            <option>Boleto</option><option>Pix</option><option>Transferência</option><option>Cartão de Crédito</option><option>Dinheiro</option>
                                        </select>
                                    </div>
                                    <div class="form-group"><label>Condição</label><select id="condicao-pagamento" style="width: 100%; padding: 8px; border-radius: 4px; border: 2px solid var(--color-primary-light);"><option value="vista">À Vista</option><option value="prazo">A Prazo (Parcelado)</option></select></div>
                                </div>
                                <div style="flex: 2; background: #fdfdfd; padding: 20px; border: 1px solid #f0f0f0; border-radius: 8px; min-height: 200px;">
                                    <div id="detalhes-vista">
                                        <label style="display: flex; align-items: flex-start; gap: 10px; cursor: pointer; padding: 15px; background: #ecfdf5; border: 1px solid #d1fae5; border-radius: 6px;">
                                            <input type="checkbox" id="check-pagar-agora" style="width: 18px; height: 18px; margin-top: 2px;">
                                            <div style="flex: 1;">
                                                <span style="display: block; font-weight: 600; color: #065f46;">Pagar / Baixar Agora</span>
                                                <span style="display: block; font-size: 0.85rem; color: #047857;">O lançamento será marcado como "Pago" e o valor debitado da conta.</span>
                                                
                                                <div id="container-data-pagamento" style="display: none; margin-top: 10px; border-top: 1px dashed #a7f3d0; padding-top: 10px;">
                                                    <label style="font-size: 0.85rem; font-weight: 600; color: #065f46; display: block; margin-bottom: 5px;">Data do Pagamento:</label>
                                                    <input type="date" id="data-pagamento-real" class="form-control" style="background: white; border: 1px solid #a7f3d0;">
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div id="detalhes-prazo" style="display: none;">
                                        <div style="display: flex; gap: 10px; align-items: flex-end; margin-bottom: 20px;">
                                            <div class="form-group" style="flex: 1;"><label>Nº Parcelas</label><input type="number" id="num-parcelas" value="3" min="2" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;"></div>
                                            <button type="button" id="btn-gerar-parcelas" class="btn btn-primary" style="height: 42px; margin-bottom: 1px;"><i class="fas fa-sync-alt"></i> Gerar Parcelas</button>
                                        </div>
                                        <div class="data-table-container"><table class="data-table" id="tabela-parcelas"><thead><tr><th width="50">#</th><th>Vencimento</th><th>Valor (R$)</th></tr></thead><tbody></tbody></table></div>
                                        <div class="form-group" style="margin-top: 10px; text-align: right;"><small style="color: var(--text-muted);">Total Parcelado: <strong id="total-parcelado-display">R$ 0,00</strong></small></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section form-section-obs" style="margin-top: 25px;">
                             <h3 style="border-bottom: 1px solid #eee; padding-bottom: 10px; margin-bottom: 20px;">Observações</h3>
                             <textarea id="obs-lancamento" class="form-control" rows="3" placeholder="Insira observações gerais sobre este documento..."></textarea>
                        </div>

                        <div class="form-section form-section-anexos" style="margin-top: 25px;">
                            <h3 style="border-bottom: 1px solid #eee; padding-bottom: 10px; margin-bottom: 20px;"><i class="fas fa-paperclip" style="color:#666; margin-right:5px;"></i> Anexos e Documentos</h3>
                            <div id="drop-zone" style="border: 2px dashed #cbd5e1; border-radius: 8px; padding: 30px; text-align: center; background: #f8fafc; cursor: pointer;">
                                <input type="file" id="file-upload-input" multiple style="display: none;">
                                <i class="fas fa-cloud-upload-alt fa-3x" style="color: #94a3b8; margin-bottom: 15px;"></i>
                                <p style="margin: 0; color: #475569; font-weight: 500;">Clique ou arraste arquivos aqui</p>
                                <p style="margin: 5px 0 0; color: #94a3b8; font-size: 0.85rem;">PDF, XML, Imagens (Máx 5MB)</p>
                            </div>
                            <div id="lista-anexos" style="margin-top: 15px; display: grid; gap: 10px;"></div>
                        </div>

                        <div class="form-actions" style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #eee;">
                            <button type="button" class="btn" style="background: #e5e7eb;" id="btn-cancelar-lancamento">Cancelar</button>
                            <button type="submit" class="btn btn-primary">Salvar Lançamento</button>
                        </div>
                    </form>
                    
                    <datalist id="list-plano-contas">${this.getPlanoContasOptionsHTML()}</datalist>
                    <datalist id="list-safras">${this.getSafrasOptionsHTML()}</datalist>
                    <datalist id="list-materiais">${this.getMateriaisOptionsHTML()}</datalist>
                </div>
            `;

            this.hookFormEvents(container);

            if (this._pendingEditId) {
                const idToLoad = this._pendingEditId;
                this._pendingEditId = null;
                setTimeout(() => this.loadLancamentoForEdit(idToLoad), 50);
            } else if (this._pendingCloneData) {
                // --- CLONE LOGIC STARTS HERE ---
                const data = this._pendingCloneData;
                this._pendingCloneData = null; // Clear immediately

                console.log("Applying Cloned Data:", data);

                setTimeout(async () => {
                    const form = container.querySelector('#form-lancamento');
                    if (!form) return;

                    // 1. Basic Fields - COPY EVERYTHING (User will edit what's needed)
                    form.querySelector('#tipo-documento').value = data.detalhes?.tipo_doc || 'Nota Fiscal (NFe)';

                    // Copy Document Number (User can change it manually)
                    form.querySelector('#num-documento').value = data.num_doc || '';

                    // Copy Dates (User can adjust)
                    form.querySelector('#data-emissao').value = data.data_emissao || new Date().toISOString().split('T')[0];
                    form.querySelector('#data-vencimento').value = data.data_vencimento?.split('T')[0] || new Date().toISOString().split('T')[0];

                    // Copy Total Value
                    const valorTotalInput = form.querySelector('#valor-total-nota');
                    if (valorTotalInput && data.valor) {
                        valorTotalInput.value = data.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    }

                    // 2. Partner (Async Select)
                    const selParceiro = form.querySelector('#parceiro-select');
                    if (data.parceiro_id) {
                        // Check if exists
                        if ([...selParceiro.options].some(o => o.value == data.parceiro_id)) {
                            selParceiro.value = data.parceiro_id;
                        } else {
                            // Fetch specific partner if missing from basic list? (Usually list has all)
                            // For now assume list is complete or handle mismatch
                        }
                    }

                    // 3. Payment Details
                    form.querySelector('#conta-banco').value = data.conta_id || '';
                    if (data.detalhes?.forma_pagamento) form.querySelector('#forma-pagamento').value = data.detalhes.forma_pagamento;

                    // Condition (Vista/Prazo)
                    const cond = data.detalhes?.condicao || 'vista';
                    form.querySelector('#condicao-pagamento').value = cond;
                    form.querySelector('#condicao-pagamento').dispatchEvent(new Event('change'));

                    // 4. Description
                    form.querySelector('#obs-lancamento').value = data.detalhes?.obs || '';

                    // 5. Items or Simple Mode
                    const modo = data.detalhes?.modo || 'sem_itens';
                    const radio = form.querySelector(`input[name="modo_lancamento"][value="${modo}"]`);
                    if (radio) {
                        radio.checked = true;
                        radio.dispatchEvent(new Event('change'));

                        // Populate Mode Specifics
                        if (modo === 'sem_itens') {
                            form.querySelector('#desc-sem-itens').value = data.descricao || '';

                            // Category
                            if (data.categoria) {
                                const catInp = form.querySelector('#categoria-search');
                                const catHidden = form.querySelector('#categoria-contabil');

                                // Try to find name map
                                const catFull = (this.planoContasData || []).find(c => c.codigo == data.categoria);
                                const display = catFull ? `${catFull.codigo} - ${catFull.nome}` : data.categoria;

                                if (catInp) catInp.value = display;
                                if (catHidden) catHidden.value = data.categoria;
                            }

                            // Value
                            const valInp = form.querySelector('#valor-total-sem-itens');
                            const det = data.detalhes || {};
                            // Ensure parsing, prefer valor_bruto if > 0
                            const vBruto = parseFloat(det.valor_bruto || 0);
                            const vLiquido = parseFloat(data.valor || 0);
                            const valShow = (vBruto > 0) ? vBruto : vLiquido;

                            if (valInp) valInp.value = valShow.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

                        } else if (modo === 'com_itens' && data.detalhes?.itens) {
                            const containerItens = form.querySelector('#items-container');
                            containerItens.innerHTML = ''; // Clear empty row

                            // Re-create items
                            for (const item of data.detalhes.itens) {
                                document.getElementById('btn-add-item')?.click(); // Add Row
                                await new Promise(r => setTimeout(r, 10)); // Tiny yield for DOM

                                const row = containerItens.lastElementChild;
                                if (row) {
                                    // Search Input (Visual)
                                    const searchInp = row.querySelector('.item-material-search');
                                    if (searchInp) searchInp.value = item.nome;

                                    // Qtd
                                    row.querySelector('.item-qtd').value = item.qtd;

                                    // Value
                                    const vunit = item.valor_unitario || (item.total / item.qtd);
                                    const vunitInp = row.querySelector('.item-vunit');
                                    vunitInp.value = vunit.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });

                                    // Discount (Restore)
                                    const descInp = row.querySelector('.item-desc');
                                    if (descInp && item.desconto_unit) {
                                        descInp.value = parseFloat(item.desconto_unit).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
                                        descInp.dispatchEvent(new Event('input', { bubbles: true }));
                                    }

                                    // Trigger Calc for Unit Value
                                    vunitInp.dispatchEvent(new Event('input', { bubbles: true }));

                                    // Category Per Item
                                    if (item.categoria) {
                                        const selCat = row.querySelector('.item-plano-select');
                                        if (selCat) selCat.value = item.categoria;
                                    }
                                }
                            }
                        }
                    }

                    window.FazendaRP.Toast.show('info', 'Duplicado', 'Dados copiados! Verifique e salve.');

                }, 100);
            }

        } catch (err) {
            container.innerHTML = `<div style="color:red; padding:20px;">Erro ao carregar formulário: ${err.message}</div>`;
        }
    },

    hookFormEvents: function (container) {
        // --- EVENT LISTENERS ---
        // Modo Toggle (Com/Sem Itens)
        const radiosModo = container.querySelectorAll('input[name="modo_lancamento"]');
        const dynamicArea = container.querySelector('#dynamic-area');

        const handleModo = (e) => {
            if (e.target.value === 'com_itens') {
                dynamicArea.innerHTML = this.renderAreaComItens();
                this.setupItensLogic(container);
            } else {
                dynamicArea.innerHTML = this.renderAreaSemItens();
                this.setupCategoriaDropdown(container);
            }
            this.setupRateioLogic(container); // Rateio always below items

            // Trigger Machine Rateio logic if Sem Itens
            if (e.target.value === 'sem_itens') {
                this.setupMachineRateio(container);
            } else {
                const areaM = container.querySelector('#area-rateio-maquinas');
                if (areaM) areaM.innerHTML = ''; // Clear if switching away
            }
            if (window.jQuery && window.jQuery.fn.mask) window.jQuery(container).find('.currency-mask').mask("#.##0,00", { reverse: true });
        };
        radiosModo.forEach(r => r.addEventListener('change', handleModo));

        // Default Render
        if (!container.querySelector('#edit-lanc-id').value) {
            dynamicArea.innerHTML = this.renderAreaSemItens(); // Default
            this.setupCategoriaDropdown(container);
            this.setupRateioLogic(container);
            this.setupMachineRateio(container);
            if (window.jQuery && window.jQuery.fn.mask) {
                window.jQuery(container).find('.currency-mask').mask("#.##0,00", { reverse: true });
            } else {
                // Vanilla Fallback
                container.querySelectorAll('.currency-mask').forEach(input => {
                    input.addEventListener('input', (e) => {
                        let value = e.target.value.replace(/\D/g, "");
                        if (value === "") return;
                        e.target.value = (parseInt(value) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                    });
                });
            }
        }

        // Magic Box
        const btnMagic = container.querySelector('#btn-magic-process');
        if (btnMagic) btnMagic.addEventListener('click', () => this.parseMagicText(container));

        // Condicao Pagamento (Vista/Prazo)
        const selectCondicao = container.querySelector('#condicao-pagamento');
        const divVista = container.querySelector('#detalhes-vista');
        const divPrazo = container.querySelector('#detalhes-prazo');
        selectCondicao.addEventListener('change', (e) => {
            if (e.target.value === 'vista') {
                divVista.style.display = 'block';
                divPrazo.style.display = 'none';
            } else {
                divVista.style.display = 'none';
                divPrazo.style.display = 'block';
                if (container.querySelector('#tabela-parcelas tbody').children.length === 0) this.gerarParcelas(container);
            }
        });

        // Toggle Data Pagamento
        const checkPagarAgora = container.querySelector('#check-pagar-agora');
        const containerDataPagto = container.querySelector('#container-data-pagamento');
        const inputDataPagto = container.querySelector('#data-pagamento-real');

        if (checkPagarAgora) {
            checkPagarAgora.addEventListener('change', (e) => {
                if (e.target.checked) {
                    containerDataPagto.style.display = 'block';
                    // Auto-fill with current emission date if empty
                    if (!inputDataPagto.value) {
                        const dataEmissao = container.querySelector('#data-emissao').value;
                        inputDataPagto.value = dataEmissao || new Date().toISOString().split('T')[0];
                    }
                } else {
                    containerDataPagto.style.display = 'none';
                    inputDataPagto.value = ''; // Clear or Keep? Better keep if user re-checks.
                }
            });
        }

        // Gerar Parcelas
        const btnGerar = container.querySelector('#btn-gerar-parcelas');
        if (btnGerar) btnGerar.addEventListener('click', () => this.gerarParcelas(container));

        // Conta vs Forma Pagamento (Cartão Logic)
        const selectConta = container.querySelector('#conta-banco');
        const selectForma = container.querySelector('#forma-pagamento');
        const updateForma = () => {
            const accId = parseInt(selectConta.value);
            const acc = (this.contasData || []).find(c => c.id === accId);
            if (acc && acc.tipo === 'Cartão de Crédito') {
                selectForma.value = 'Cartão de Crédito';
                selectForma.style.pointerEvents = 'none';
                selectForma.style.background = '#eee';
            } else {
                selectForma.style.pointerEvents = 'auto';
                selectForma.style.background = '';
            }
        };
        selectConta.addEventListener('change', updateForma);

        // Submit
        const form = container.querySelector('#form-lancamento');
        if (form) form.addEventListener('submit', (e) => { e.preventDefault(); this.salvarLancamento(container); });

        // Cancel
        const btnCancel = document.getElementById('btn-cancelar-lancamento');
        if (btnCancel) btnCancel.addEventListener('click', () => {
            this.renderTabContent('lancamentos');
            document.querySelector('.submenu-item[data-tab="lancamentos"]')?.classList.add('active');
        });

        // Add Parceiro
        const btnAddP = container.querySelector('#btn-add-novo-parceiro');
        if (btnAddP) btnAddP.addEventListener('click', () => {
            const preFill = window.FazendaRP.TempXMLPartner || null;
            if (window.FazendaRP.Pages.sistema && window.FazendaRP.Pages.sistema.openNovoParceiroModal) {
                window.FazendaRP.Pages.sistema.openNovoParceiroModal((newP) => {
                    const sel = container.querySelector('#parceiro-select');
                    const opt = document.createElement('option');
                    opt.value = newP.id;

                    const label = newP.nome_fantasia && newP.nome_fantasia !== newP.nome
                        ? `${newP.nome_fantasia} (${newP.nome})`
                        : newP.nome;

                    opt.text = label + (newP.cpf_cnpj ? ` - ${newP.cpf_cnpj}` : '');
                    sel.add(opt);
                    sel.value = newP.id;

                    // Clear temp
                    window.FazendaRP.TempXMLPartner = null;
                    btnAddP.style.border = '';
                    btnAddP.classList.remove('pulse-animation');

                }, preFill);
            }
        });

        // XML Import (Simple)
        const btnImpSimple = container.querySelector('#btn-import-xml-simple');
        const inpXmlSimple = container.querySelector('#import-xml-simple-input');
        if (btnImpSimple) btnImpSimple.addEventListener('click', () => inpXmlSimple.click());
        if (inpXmlSimple) inpXmlSimple.addEventListener('change', (e) => this.processarXML(e.target.files[0], 'simple'));

        // XML Import (Items)
        const btnImpItems = container.querySelector('#btn-import-xml-items');
        const inpXmlItems = container.querySelector('#import-xml-items-input');
        if (btnImpItems) btnImpItems.addEventListener('click', () => inpXmlItems.click());
        if (inpXmlItems) inpXmlItems.addEventListener('change', (e) => this.processarXML(e.target.files[0], 'items'));

        // Currency Masks
        container.addEventListener('input', (e) => {
            // FIXED: Removed aggressive Vanilla JS mask that caused cursor jumps.
            // .currency-mask and .decimal-mask are now handled by jQuery.mask in setupItensLogic and global init.
            if (e.target.id === 'valor-total-sem-itens') {
                // Keep this trigger for rateio but rely on jQuery mask for formatting
            }

            // --- SYNC HEADER TOTAL TO SIMPLE TOTAL ---
            if (e.target.id === 'valor-total-nota') {
                const modeWrapper = container.querySelector('input[name="modo_lancamento"]:checked');
                if (modeWrapper && modeWrapper.value === 'sem_itens') {
                    const detailTotal = container.querySelector('#valor-total-sem-itens');
                    if (detailTotal) {
                        detailTotal.value = e.target.value;
                        // Trigger input on detail to update any downstream calcs (Rateio, etc)
                        // Use timeout to avoid conflict with current event bubble? No, separate element.
                        detailTotal.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }
            // decimal-mask logic removed (handled by jquery.mask)

            // Auto Rateio Trigger for Simple Mode
            if (e.target.id === 'categoria-contabil' || e.target.id === 'valor-total-sem-itens') {
                this.setupGlobalRateio(container);
                this.setupMachineRateio(container); // Ensure it stays visible/updated
            }
        });

        // Dropzone Event Delegation (Fix for dynamic re-renders)
        container.addEventListener('click', (e) => {
            const dropZone = e.target.closest('#drop-zone');
            if (dropZone) {
                console.log("Delegated Dropzone Click triggered");
                const fileInput = container.querySelector('#file-upload-input');
                if (fileInput) fileInput.click();
            }
        });

        // Dropzone Drag & Drop Events (Delegated via Container? Or Re-bind? Re-binding is hard. 
        // Let's rely on standard events if element exists, or delegate dragover/drop too?)
        // Drag events bubble. So we can delegate.
        container.addEventListener('dragover', (e) => {
            const dropZone = e.target.closest('#drop-zone');
            if (dropZone) {
                e.preventDefault();
                dropZone.style.borderColor = 'var(--color-primary)';
                dropZone.style.background = '#e0f2f1';
            }
        });
        container.addEventListener('dragleave', (e) => {
            const dropZone = e.target.closest('#drop-zone');
            if (dropZone) {
                e.preventDefault();
                dropZone.style.borderColor = '#cbd5e1';
                dropZone.style.background = '#f8fafc';
            }
        });
        container.addEventListener('drop', (e) => {
            const dropZone = e.target.closest('#drop-zone');
            if (dropZone) {
                e.preventDefault();
                dropZone.style.borderColor = '#cbd5e1';
                dropZone.style.background = '#f8fafc';
                if (e.dataTransfer.files.length > 0) {
                    this.uploadFiles(e.dataTransfer.files);
                }
            }
        });

        // File Input Change (Delegated or Direct? Direct is safer as ID is unique inside form usually)
        // But File Input is inside dynamic HTML? Yes "#file-upload-input" is rendered in HTML string.
        // So we must delegate change event for it too.
        container.addEventListener('change', (e) => {
            if (e.target.id === 'file-upload-input') {
                if (e.target.files.length > 0) {
                    this.uploadFiles(e.target.files);
                }
            }
            if (e.target.id === 'categoria-contabil') {
                this.setupGlobalRateio(container);
            }
        });

        // --- CLIPBOARD LOGIC ---
        const clipboardData = sessionStorage.getItem('fazenda_erp_clipboard');
        const clipArea = container.querySelector('#clipboard-area');

        if (clipboardData && clipArea) {
            clipArea.style.display = 'flex';

            // Paste Action
            container.querySelector('#btn-paste-clipboard').addEventListener('click', () => {
                try {
                    const data = JSON.parse(clipboardData);
                    this.preencherFormulario(data); // Reuses existing clone logic

                    // Feedback and Cleanup
                    clipArea.style.display = 'none';
                    sessionStorage.removeItem('fazenda_erp_clipboard'); // Consume it (single use?) Or keep? Better consume to avoid confusing user later.
                    window.FazendaRP.Toast.show('success', 'Dados Colados', 'Formulário preenchido com sucesso.');
                } catch (e) {
                    console.error(e);
                    alert('Erro ao ler clipboard.');
                }
            });

            // Clear Action
            container.querySelector('#btn-clear-clipboard').addEventListener('click', () => {
                sessionStorage.removeItem('fazenda_erp_clipboard');
                clipArea.style.display = 'none';
            });
        }
    },

    // --- HTML GENERATORS ---
    renderAreaSemItens: function () {
        return `
            <div style="background: #f8fafc; padding: 20px; border-radius: 8px; border: 1px solid #e2e8f0;">
                <h4 style="margin-top: 0; color: #475569; margin-bottom: 15px;">Detalhes do Lançamento</h4>
                <div class="form-row">
                     <div class="form-group" style="flex:2;">
                        <label>Descrição do Gasto / Receita</label>
                        <input type="text" id="desc-sem-itens" placeholder="Ex: Compra de Diesel Posto X...">
                     </div>
                <div class="form-group">
                    <label>Categoria (Plano de Contas)</label>
                    <div class="custom-dropdown-container" style="width: 100%;">
                        <input type="text" id="categoria-search" placeholder="Busque por nome ou código..." autocomplete="off" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
                        <input type="hidden" id="categoria-contabil">
                        <div id="categoria-results" class="custom-dropdown-results"></div>
                    </div>
                 </div>
                 <div class="form-group">
                    <label>Valor Total (R$)</label>
                    <input type="text" id="valor-total-sem-itens" class="currency-mask" placeholder="R$ 0,00" style="font-size: 1.1rem; font-weight: 600; color: #0f766e;">
                 </div>
                </div>
            </div>
            <div id="area-rateio"></div>
            <div id="area-rateio-maquinas"></div>
        `;
    },

    renderAreaComItens: function () {
        return `
            <div style="background: #fff; border: 1px solid #ddd; border-radius: 8px; overflow: hidden;">
                <div style="padding: 10px 15px; background: #f1f5f9; border-bottom: 1px solid #ddd; font-weight: 600; color: #475569;">
                    <span>Itens da Nota</span>
                </div>
                <!-- Header Row for Labels (Optional, but mimics table look if desired, keeping simple for now) -->
                <div id="items-container" style="padding: 15px;"></div>
                
                <div style="padding: 10px 15px; border-top: 1px dashed #eee;">
                    <button type="button" id="btn-add-item" style="width: 100%; border: 1px dashed #ccc; color: #64748b; background: #fafafa; padding: 8px; border-radius: 6px; cursor: pointer;">+ Adicionar Item</button>
                </div>

                <div style="padding: 10px 15px; background: #f8fafc; border-top: 1px solid #ddd; text-align: right;">
                    <strong>Total Itens: <span id="total-itens-display">R$ 0,00</span></strong>
                </div>
            </div>
            <div id="area-rateio"></div>
        `;
    },

    setupItensLogic: function (container) {
        const btnAdd = container.querySelector('#btn-add-item');
        const itemsContainer = container.querySelector('#items-container');
        if (btnAdd) {
            btnAdd.addEventListener('click', () => {
                try {
                    const div = document.createElement('div');
                    div.innerHTML = this.getItemRowHTML();
                    const newRow = div.firstElementChild;
                    itemsContainer.appendChild(newRow);

                    // 1. Setup Material Dropdown (Critical)
                    this.setupMaterialDropdown(newRow);

                    // 2. Setup Rateio Logic
                    this.setupItemRateioEvents(newRow);

                    // 3. Populate Account Select
                    this.populateAccountSelect(newRow.querySelector('.item-plano-select'));

                    // 4. Setup Mask for Qtd
                    if (window.jQuery && window.jQuery.fn.mask) {
                        window.jQuery(newRow).find('.decimal-mask').mask("#.##0,000", { reverse: true });
                        window.jQuery(newRow).find('.currency-mask').mask("#.##0,00", { reverse: true });
                    }
                } catch (err) {
                    console.error("Financeiro: Erro ao adicionar novo item:", err);
                }
            });
        }

        // Event delegation for inputs
        if (itemsContainer) {
            itemsContainer.addEventListener('input', (e) => {
                const target = e.target;

                // CALCULATION LOGIC
                // STRICT ORDER: Apply Mask First -> Then Calculate
                if (target.classList.contains('currency-mask')) {
                    let v = target.value.replace(/\D/g, "");
                    target.value = (Number(v) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
                } else if (target.classList.contains('unit-value-mask')) {
                    let v = target.value.replace(/\D/g, "");
                    // 4 decimals: divide by 10000
                    target.value = (Number(v) / 10000).toLocaleString("pt-BR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
                }
                // decimal-mask logic removed (handled by jquery.mask)

                // Now proceed with calculation using the formatted value
                if (target.classList.contains('item-qtd')) {
                    // REVERSE LOGIC: Change Qtd -> Update Unit Price (Keep Total Fixed)
                    const row = target.closest('.item-row');
                    if (row) {
                        const qtdInput = row.querySelector('.item-qtd');
                        const vunitInput = row.querySelector('.item-vunit');
                        const descInput = row.querySelector('.item-desc');
                        const totalInput = row.querySelector('.item-total');

                        const rawQtd = qtdInput.value.replace(/\./g, "").replace(",", ".");
                        const qtd = parseFloat(rawQtd) || 0;

                        // Get Locked Total (Net)
                        let rawTotal = totalInput.value.replace('R$', '').trim().replace(/\./g, '').replace(',', '.');
                        const totalNet = parseFloat(rawTotal) || 0;

                        // Get Current Discount (Unitary)
                        let rawDesc = descInput ? descInput.value.replace('R$', '').trim().replace(/\./g, '').replace(',', '.') : '0';
                        const unitDiscount = parseFloat(rawDesc) || 0;

                        if (qtd > 0) {
                            // Net Unit = Total / Qty
                            const netUnit = totalNet / qtd;
                            // Gross Unit = Net Unit + Discount
                            const grossUnit = netUnit + unitDiscount;

                            vunitInput.value = grossUnit.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
                        }
                    }

                } else if (target.classList.contains('item-vunit') || target.classList.contains('item-desc')) {
                    // FORWARD LOGIC: Change Unit/Desc -> Update Total
                    const row = target.closest('.item-row');
                    if (row) {
                        const qtdInput = row.querySelector('.item-qtd');
                        const vunitInput = row.querySelector('.item-vunit');
                        const descInput = row.querySelector('.item-desc');
                        const totalInput = row.querySelector('.item-total');

                        const rawQtd = qtdInput.value.replace(/\./g, "").replace(",", ".");
                        const qtd = parseFloat(rawQtd) || 0;

                        // Parse Unit Price
                        let rawUnit = vunitInput.value.replace('R$', '').trim();
                        rawUnit = rawUnit.replace(/\./g, '').replace(',', '.');
                        const vunit = parseFloat(rawUnit) || 0;

                        // Parse Discount (Unitary)
                        let rawDesc = descInput ? descInput.value.replace('R$', '').trim() : '0';
                        rawDesc = rawDesc.replace(/\./g, '').replace(',', '.');
                        const unitDiscount = parseFloat(rawDesc) || 0;

                        // Calculate Net Unit Price
                        const netUnit = vunit - unitDiscount;

                        // Calculate Total: (Net Unit * Qty)
                        const netTotal = netUnit * qtd;

                        // Update Total Input
                        totalInput.value = netTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                        totalInput.dispatchEvent(new Event('input', { bubbles: true })); // Propagate

                        this.updateItensTotal(itemsContainer);
                    }
                }

                // Recalc Total if total manually changed (less likely but possible if editable)
                if (target.classList.contains('item-total')) {
                    this.updateItensTotal(itemsContainer);
                }

                if (target.classList.contains('item-total') || target.classList.contains('item-plano-select') || target.classList.contains('item-qtd') || target.classList.contains('item-vunit')) {
                    this.calculateAutoRateio(container);
                }
            });

            // Format V.Unit on Blur to 4 decimals
            itemsContainer.addEventListener('focusout', (e) => {
                if (e.target.classList.contains('item-vunit') || e.target.classList.contains('item-desc')) {
                    let raw = e.target.value.replace('R$', '').trim();
                    raw = raw.replace(/\./g, '').replace(',', '.');
                    const val = parseFloat(raw);
                    if (!isNaN(val)) {
                        // Re-format to user string: 4 decimals.
                        e.target.value = val.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
                    }
                }
            });

            itemsContainer.addEventListener('focusin', (e) => {
                // Focus Logic for Custom Dropdown handled in setupMaterialDropdown
                if (e.target.classList.contains('item-material-search')) {
                    // Just ensure logic is compliant
                }
            });
            itemsContainer.addEventListener('change', (e) => {
                if (e.target.classList.contains('item-plano-select')) {
                    this.calculateAutoRateio(container);
                }

                // Logic for Machine Select (Dynamic Meter Label)
                if (e.target.classList.contains('item-maquina-select')) {
                    const opt = e.target.options[e.target.selectedIndex];
                    const tipo = (opt.dataset.tipo || '').toLowerCase();
                    const row = e.target.closest('.item-row');
                    const horInput = row.querySelector('.item-horimetro');

                    if (horInput) {
                        if (tipo.includes('implemento')) {
                            horInput.style.display = 'none';
                            horInput.value = '';
                        } else if (/caminhonete|camionete|carro|ve[íi]culo|moto|picape|pickup|utilit[áa]rio|passeio/i.test(tipo)) {
                            horInput.style.display = 'block';
                            horInput.placeholder = 'Odômetro (Km)';
                        } else {
                            // Default (Tractors, etc.)
                            horInput.style.display = 'block';
                            horInput.placeholder = 'Horímetro (Hrs)';
                        }
                    }
                }
            });

            // Create Observer for node removal (to update total when deleting row)
            const observer = new MutationObserver((mutations) => {
                this.updateItensTotal(itemsContainer);
            });
            observer.observe(itemsContainer, { childList: true });
        }

        // Initial Row
        if (itemsContainer && itemsContainer.children.length === 0 && btnAdd) btnAdd.click();
    },

    setupCategoriaDropdown: function (container) {
        const input = container.querySelector('#categoria-search');
        const hidden = container.querySelector('#categoria-contabil');
        const results = container.querySelector('#categoria-results');

        if (!input || !results) return;

        const showResults = (query) => {
            const term = (query || '').toLowerCase();
            // Strict Filter: ANALITICA only
            const matches = (this.planoContasData || []).filter(c => {
                if (c.tipo !== 'ANALITICA' && c.tipo !== 'CONTA') return false; // Strict
                const text = `${c.codigo} - ${c.nome}`;
                return text.toLowerCase().includes(term);
            });

            if (matches.length === 0) {
                results.style.display = 'none';
                return;
            }

            results.innerHTML = matches.map(c => `
                <div class="custom-dropdown-item" data-val="${c.codigo} - ${c.nome}">
                    <strong>${c.codigo}</strong> - ${c.nome}
                </div>
            `).join('');
            results.style.display = 'block';

            // Click Handler
            results.querySelectorAll('.custom-dropdown-item').forEach(div => {
                div.addEventListener('mousedown', () => {
                    const val = div.dataset.val;
                    input.value = val;
                    if (hidden) hidden.value = val;
                    results.style.display = 'none';

                    // Trigger Rateio Check
                    this.setupGlobalRateio(container);
                });
            });
        };

        input.addEventListener('input', (e) => showResults(e.target.value));
        input.addEventListener('focus', () => showResults(input.value));
        input.addEventListener('blur', () => setTimeout(() => results.style.display = 'none', 200)); // Delay for click
    },

    // --- GLOBAL RATEIO (SEM ITENS) ---
    setupGlobalRateio: function (container) {
        const area = container.querySelector('#area-rateio');
        const catInput = container.querySelector('#categoria-contabil'); // Hidden ID 
        const totalInput = container.querySelector('#valor-total-sem-itens');

        if (!area || !catInput || !totalInput) return;

        // Check Visibility
        const checkVisibility = () => {
            const val = catInput.value || '';
            // Logic: starts with 1.1 or 2.1
            if (val.startsWith('1.1') || val.startsWith('2.1')) {
                area.style.display = 'block';

                // Render Structure if Empty
                if (!area.querySelector('.rateio-global-container')) {
                    area.innerHTML = `
                    <div class="rateio-global-container" style="background: #fffbeb; border: 1px solid #fcd34d; padding: 15px; border-radius: 8px; margin-top: 20px;">
                        <h5 style="margin: 0 0 10px 0; color: #92400e; font-size: 0.95rem; display: flex; justify-content: space-between; align-items: center;">
                            <span><i class="fas fa-tractor"></i> Rateio por Safra (Obrigatório)</span>
                            <span class="rateio-feedback" style="font-size: 0.9em;"></span>
                        </h5>
                        <div class="rateio-rows-area"></div>
                        <button type="button" class="btn-add-safra-global" style="background: #fef3c7; border: 1px solid #fbbf24; color: #92400e; padding: 5px 10px; border-radius: 4px; font-size: 0.85rem; cursor: pointer; margin-top: 10px;">
                            + Adicionar Safra
                        </button>
                    </div>
                `;

                    // Bind Add Button
                    area.querySelector('.btn-add-safra-global').addEventListener('click', () => addGlobalSafraRow());

                    // Auto-Add First Row
                    addGlobalSafraRow();
                }
                updateCalculations();
            } else {
                area.style.display = 'none';
                area.innerHTML = ''; // Clear to avoid ghost data
            }
        };

        // Add Row Helper
        const addGlobalSafraRow = () => {
            const rowsContainer = area.querySelector('.rateio-rows-area');
            if (!rowsContainer) return;

            const div = document.createElement('div');
            div.className = 'rateio-row-global';
            div.style.cssText = 'display: flex; gap: 10px; margin-bottom: 5px; align-items: center;';

            const safrasOpts = this.getSafrasOptionsHTML();

            div.innerHTML = `
            <select class="safra-select" style="flex: 2; padding: 6px; border: 1px solid #d1d5db; border-radius: 4px;">${safrasOpts}</select>
            <input type="text" class="safra-valor currency-mask" placeholder="R$ 0,00" style="flex: 1; padding: 6px; border: 1px solid #d1d5db; border-radius: 4px;">
            <span class="safra-percent" style="flex: 0.5; font-size: 0.8rem; color: #666; text-align: right;">0%</span>
            <button type="button" class="btn-del-safra" style="color: red; border: none; background: none; cursor: pointer;">&times;</button>
        `;

            // Events
            div.querySelector('.btn-del-safra').onclick = () => {
                div.remove();
                updateCalculations();
            };

            const valInput = div.querySelector('.safra-valor');
            valInput.addEventListener('input', updateCalculations);

            // Auto-fill Value if first
            if (rowsContainer.children.length === 0) {
                const total = parseFloat(totalInput.value.replace(/\D/g, "")) / 100 || 0;
                if (total > 0) valInput.value = total.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            }

            rowsContainer.appendChild(div);

            // Mask
            if (window.jQuery && window.jQuery.fn.mask) {
                window.jQuery(div).find('.currency-mask').mask("#.##0,00", { reverse: true });
            }

            updateCalculations();
        };

        // Calculations
        const updateCalculations = () => {
            const totalParams = parseFloat(totalInput.value.replace(/\D/g, "")) / 100 || 0;
            let sumRateio = 0;
            const rowsContainer = area.querySelector('.rateio-rows-area');
            if (!rowsContainer) return;

            const safraRows = rowsContainer.querySelectorAll('.rateio-row-global');
            safraRows.forEach(r => {
                const valInp = r.querySelector('.safra-valor');
                const val = parseFloat(valInp.value.replace(/\D/g, "")) / 100 || 0;
                sumRateio += val;

                const perc = totalParams > 0 ? (val / totalParams) * 100 : 0;
                r.querySelector('.safra-percent').innerText = perc.toFixed(1) + '%';
            });

            // Feedback
            const feedbackTotal = area.querySelector('.rateio-feedback');
            if (feedbackTotal) {
                const diff = Math.abs(totalParams - sumRateio);
                const color = diff < 0.02 ? 'green' : 'red';
                feedbackTotal.innerHTML = `
                Total: <span style="color:${color}">${sumRateio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span> / 
                <span class="target-total">${totalParams.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
            `;
            }
        };

        // Global Listeners
        // Re-verify on Total Change (to update feedback limits)
        totalInput.addEventListener('input', updateCalculations);

        checkVisibility();
    },

    // --- MACHINE RATEIO (SEM ITENS) ---
    setupMachineRateio: function (container) {
        const area = container.querySelector('#area-rateio-maquinas');
        const modoInput = container.querySelector('input[name="modo_lancamento"]:checked');

        if (!area) return;

        // Hide if not "sem_itens" (just safe check)
        if (modoInput && modoInput.value !== 'sem_itens') {
            area.style.display = 'none';
            return;
        }

        area.style.display = 'block';

        // Render Structure if Empty
        if (!area.querySelector('.rateio-maquinas-container')) {
            area.innerHTML = `
            <div class="rateio-maquinas-container" style="background: #f0f9ff; border: 1px solid #bae6fd; padding: 15px; border-radius: 8px; margin-top: 20px;">
                <h5 style="margin: 0 0 10px 0; color: #0369a1; font-size: 0.95rem; display: flex; justify-content: space-between; align-items: center;">
                    <span><i class="fas fa-tools"></i> Custos de Máquinas (Opcional)</span>
                </h5>
                <p style="font-size: 0.8rem; color: #0c4a6e; margin-bottom: 10px;">
                   Vincule custos parciais ou totais a uma ou mais máquinas. O saldo restante será considerado despesa geral.
                </p>
                <div class="rateio-maquinas-rows-area"></div>
                <button type="button" class="btn-add-maquina-custo" style="background: #e0f2fe; border: 1px solid #7dd3fc; color: #0369a1; padding: 5px 10px; border-radius: 4px; font-size: 0.85rem; cursor: pointer; margin-top: 10px;">
                    + Adicionar Máquina
                </button>
            </div>
            `;

            // Logic to Add Row
            const btnAdd = area.querySelector('.btn-add-maquina-custo');
            const rowsContainer = area.querySelector('.rateio-maquinas-rows-area');

            const addRow = () => {
                const div = document.createElement('div');
                div.className = 'rateio-maquina-row';
                div.style.display = 'flex';
                div.style.gap = '10px';
                div.style.marginBottom = '10px';
                div.style.alignItems = 'center';

                // Dropdown Options
                const options = '<option value="">Selecione a Máquina...</option>' +
                    (this.maquinasCache || []).map(m => `<option value="${m.id}">${m.nome}</option>`).join('');

                div.innerHTML = `
                    <select class="maquina-select" style="flex: 2; padding: 6px; border: 1px solid #ccc; border-radius: 4px;">${options}</select>
                    <input type="text" class="maquina-horimetro" placeholder="Horímetro/Km" style="flex: 1; min-width: 80px; padding: 6px; border: 1px solid #ccc; border-radius: 4px;">
                    <input type="text" class="maquina-valor currency-mask" placeholder="R$ 0,00" style="flex: 1; min-width: 100px; padding: 6px; border: 1px solid #ccc; border-radius: 4px;">
                    <button type="button" class="rateio-remove-btn" style="background: transparent; border: none; color: #ef4444; cursor: pointer;">
                        <i class="fas fa-trash"></i>
                    </button>
                `;

                // Remove Logic
                div.querySelector('.rateio-remove-btn').onclick = () => div.remove();

                // Mask
                // Mask
                if (window.jQuery && window.jQuery.fn.mask) {
                    window.jQuery(div).find('.currency-mask').mask("#.##0,00", { reverse: true });
                } else {
                    const inp = div.querySelector('.currency-mask');
                    if (inp) {
                        inp.addEventListener('input', (e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            if (value === "") return;
                            e.target.value = (parseInt(value) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                        });
                    }
                }

                rowsContainer.appendChild(div);

                // Auto-Fill with remaining or total
                const totalInput = container.querySelector('#valor-total-sem-itens');
                if (totalInput && totalInput.value) {
                    let total = 0;
                    const valStr = totalInput.value;

                    if (valStr.includes(',')) {
                        // Masked: "1.000,00" -> 1000.00
                        total = parseFloat(valStr.replace(/\./g, '').replace(',', '.')) || 0;
                    } else {
                        // Unmasked: "880" -> 880.00
                        // Check if it has dots but no comma (US format "1000.00") - unlikely in BRL context but safe check
                        // Assume plain number if no comma
                        total = parseFloat(valStr) || 0;
                    }

                    if (total > 0) {
                        const valInput = div.querySelector('.maquina-valor');
                        if (valInput) valInput.value = total.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                    }
                }
            };

            btnAdd.onclick = addRow;
        }
    },

    updateItensTotal: function (container) {
        let total = 0;
        const totalInputs = container.querySelectorAll('.item-total');

        totalInputs.forEach(input => {
            // Parse "R$ 1.000,00"
            const clean = input.value.replace(/[^\d,]/g, '').replace(',', '.');
            total += parseFloat(clean) || 0;
        });

        // Update Label
        // We need to find the label. It is in the parent of itemsContainer usually, or we search globally in container.
        // renderAreaComItens creates '#items-container' inside parent. The label is sibling.
        // We passed 'container' (the form wrapper) to setupItensLogic? No, we passed 'container' (main-content).
        // Check finding logic.
        const label = document.getElementById('total-itens-display');
        if (label) {
            label.innerText = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    },

    // --- NEW: Custom Material Dropdown Logic ---
    setupMaterialDropdown: function (row) {
        const input = row.querySelector('.item-material-search');
        const resultsDiv = row.querySelector('.custom-dropdown-results');

        if (!input || !resultsDiv) return;

        // Populate and Show
        const showResults = (query) => {
            const data = window.FazendaRP.SuprimentosData || [];
            if (data.length === 0) {
                console.warn("Financeiro: Dropdown opened but SuprimentosData is empty.");
                // return; // Don't return, let it show "No results"
            }

            const term = (query || '').toLowerCase().trim();

            // Filter: Material/Item types OR empty type (permissive)
            const matches = data.filter(i => {
                if (i.status === 'Inativo') return false;

                // Type Check: Allow 'ITEM', 'MATERIAL', or missing/null (legacy)
                const type = (i.tipo || '').toUpperCase().trim();
                const validTypes = ['ITEM', 'MATERIAL', ''];
                if (!validTypes.includes(type) && type.length > 0) return false; // Only filter OUT if it has a known Invalid type

                const nameMatch = (i.nome || '').toLowerCase().includes(term);
                return nameMatch;
            });

            // Render
            if (matches.length === 0) {
                resultsDiv.innerHTML = `<div style="padding:10px; color:#999; text-align:center; font-style:italic;">Nenhum material encontrado.</div>`;
            } else {
                const limited = matches.slice(0, 20);
                resultsDiv.innerHTML = limited.map(item => {
                    // Normalize accounts to array
                    let accounts = [];
                    if (item.contas) {
                        if (Array.isArray(item.contas)) accounts = item.contas;
                        else accounts = [item.contas]; // Single value
                    }
                    const accountsJson = JSON.stringify(accounts).replace(/"/g, '&quot;');
                    const unitsJson = JSON.stringify(item.unidades || ['UN']).replace(/"/g, '&quot;');

                    // Check Parent (Inheritance of requiresMachine)
                    const parent = item.parentId ? data.find(p => p.id === item.parentId) : null;
                    const reqMachine = item.requiresMachine || (parent && parent.requiresMachine);

                    return `
                    <div class="custom-dropdown-item" data-id="${item.id}" data-unit="${(item.unidades && item.unidades[0]) || 'UN'}" data-units="${unitsJson}" data-name="${(item.nome || '').replace(/"/g, '&quot;')}" data-accounts="${accountsJson}" data-requires-machine="${reqMachine || false}">
                        <strong>${item.nome}</strong>
                    </div>
                `}).join('');
            }
            resultsDiv.style.display = 'block';
        };

        // Events
        input.addEventListener('focus', () => showResults(input.value));
        input.addEventListener('input', () => showResults(input.value));

        // Hide Delayed
        input.addEventListener('blur', () => {
            setTimeout(() => resultsDiv.style.display = 'none', 300);
        });

        // Selection (Event Delegation on ResultsDiv)
        resultsDiv.addEventListener('mousedown', (e) => {
            const itemDiv = e.target.closest('.custom-dropdown-item');
            if (itemDiv) {
                e.preventDefault();
                const name = itemDiv.dataset.name;
                const unit = itemDiv.dataset.unit;
                const requiresMachine = itemDiv.dataset.requiresMachine === 'true';

                // Parse accounts properly
                let linkedAccountIds = [];
                try {
                    linkedAccountIds = JSON.parse(itemDiv.dataset.accounts || '[]');
                } catch (e) { console.error("Error parsing accounts", e); }

                // 1. Set Name
                input.value = name;

                // 2. Set Unit
                const unitSelect = row.querySelector('.item-unid');
                if (unitSelect) {
                    let allowedUnits = ['UN'];
                    try { if (itemDiv.dataset.units) allowedUnits = JSON.parse(itemDiv.dataset.units); } catch (e) { console.error(e); }

                    unitSelect.innerHTML = '';
                    allowedUnits.forEach(u => {
                        const opt = document.createElement('option');
                        opt.value = u; opt.text = u;
                        unitSelect.add(opt);
                    });

                    unitSelect.value = unit;
                }

                // 3. Update & Auto-Fill Account Select
                this.populateAccountSelect(row.querySelector('.item-plano-select'), linkedAccountIds);

                // 4. Handle Machine Fields
                const machineArea = row.querySelector('.item-machine-area');
                if (machineArea) {
                    if (requiresMachine) {
                        machineArea.style.display = 'flex';

                        // Fuel Logic
                        let fuelFilter = null;
                        const nLower = name.toLowerCase();
                        if (nLower.includes('s10') || nLower.includes('s-10')) fuelFilter = 'S10';
                        else if (nLower.includes('s500') || nLower.includes('s-500')) fuelFilter = 'S500';
                        else if (nLower.includes('gasolina')) fuelFilter = 'Gasolina';
                        else if (nLower.includes('etanol') || nLower.includes('álcool')) fuelFilter = 'Etanol';

                        this.populateMachineSelect(machineArea.querySelector('select'), fuelFilter);
                    } else {
                        machineArea.style.display = 'none';
                    }
                }



                resultsDiv.style.display = 'none';
            }
        });
    },

    populateMachineSelect: function (selectElement, fuelFilter = null) {
        if (!selectElement) return;
        let machines = this.maquinasCache || [];

        // Fuel Filtering
        if (fuelFilter) {
            const filterLower = fuelFilter.toLowerCase();
            machines = machines.filter(m => {
                let mFuels = m.combustiveis;
                if (!mFuels) return false;
                if (typeof mFuels === 'string') mFuels = mFuels.split(',').map(s => s.trim());
                if (!Array.isArray(mFuels)) return false;

                // Check match
                return mFuels.some(f => f.toLowerCase().includes(filterLower));
            });
        }

        selectElement.innerHTML = '<option value="">Selecione...</option>' +
            machines.map(m => `<option value="${m.id}" data-tipo="${m.tipo}">${m.nome} ${m.placa ? '- ' + m.placa : ''}</option>`).join('');
    },

    populateAccountSelect: function (selectElement, allowedAccountIds = null) {
        if (!selectElement) return;

        // Get all ANALYTIC accounts from cache
        let options = (this.planoContasData || []).filter(c => c.tipo === 'ANALITICA' || c.tipo === 'CONTA');

        // Filter if allowedAccountIds is provided and not empty
        if (allowedAccountIds && allowedAccountIds.length > 0) {
            // 'allowedAccountIds' likely mimics the strings saved in Supabase: "⚪ 2.1.1.4 - Descrição"
            // We need to extract the code "2.1.1.4" to match against options.

            // Create a set of normalized codes from the allowed list
            const allowedCodes = allowedAccountIds.map(val => {
                if (typeof val !== 'string') return val;
                // Remove emojis/symbols and get the code part before " - "
                const parts = val.replace(/[⚫⚪]/g, '').trim().split(' - ');
                return parts[0].trim();
            });

            console.log('DEBUG: Extracted Codes:', allowedCodes);

            const filtered = options.filter(c => {
                return allowedCodes.includes(c.codigo) || allowedCodes.some(ac => c.codigo.toString() === ac.toString());
            });

            console.log('DEBUG: Filtered Options Count:', filtered.length);

            // If we have matches, use them. If not, maybe we shouldn't show empty? 
            // Or maybe we show all if no matches found (fallback)? User wants restriction, so 0 matches is correct if data is bad.
            if (filtered.length > 0) {
                options = filtered;
            }
        }

        // Generate HTML
        const html = options.map(c => `<option value="${c.codigo} - ${c.nome}">${c.codigo} - ${c.nome}</option>`).join('');

        selectElement.innerHTML = `<option value="">Selecione...</option>` + html;

        // Auto-select if only one option (excluding the placeholder)
        if (options.length === 1) {
            selectElement.selectedIndex = 1; // Index 0 is placeholder
            selectElement.dispatchEvent(new Event('change'));
        }
    },

    setupRateioLogic: function (container) {
        // Deprecated Global Logic
    },

    setupItemRateioEvents: function (row) {
        const selectConta = row.querySelector('.item-plano-select');
        const container = row.querySelector('.item-rateio-container');
        const rowsContainer = row.querySelector('.item-rateio-rows');
        const btnAdd = row.querySelector('.btn-add-item-safra');
        const feedbackTotal = row.querySelector('.rateio-feedback');
        const itemTotalInput = row.querySelector('.item-total');

        if (!selectConta || !container) return;

        // 1. Toggle Verification
        const checkVisibility = () => {
            const val = selectConta.value; // "2.1.05 - Adubos"
            if (val && (val.startsWith('1.1') || val.startsWith('2.1'))) {
                console.log("Financeiro: Rateio triggered for account", val);
                container.style.display = 'block';
                if (rowsContainer.children.length === 0) addItemSafraRow(); // Auto-add first
                updateCalculations();
            } else {
                container.style.display = 'none';
                // Optional: Clear rows?
            }
        };
        selectConta.addEventListener('change', checkVisibility);

        // 2. Add Row Logic
        const addItemSafraRow = () => {
            const div = document.createElement('div');
            div.className = 'item-rateio-row';
            div.style.cssText = 'display: flex; gap: 10px; margin-bottom: 5px; align-items: center;';

            // Assume safrasCache is loaded
            const safrasOpts = this.getSafrasOptionsHTML();

            div.innerHTML = `
            <select class="safra-select" style="flex: 2; padding: 4px; border: 1px solid #d1d5db; border-radius: 4px;">${safrasOpts}</select>
            <div style="flex: 1; position: relative;">
                <span style="position: absolute; left: 8px; top: 50%; transform: translateY(-50%); color: #6b7280; font-size: 0.8rem;">R$</span>
                <input type="text" class="safra-valor currency-mask" placeholder="0,00" style="width: 100%; padding: 4px 4px 4px 25px; border: 1px solid #d1d5db; border-radius: 4px;">
            </div>
            <div class="safra-percent" style="width: 45px; text-align: right; font-size: 0.75rem; color: #666; padding-top: 5px;">0%</div>
            <button type="button" class="btn-remove-safra" style="color: #ef4444; border: none; background: none; cursor: pointer; padding: 0 5px;" title="Remover Safra">
                <i class="fas fa-times"></i>
            </button>
        `;

            // Listeners
            div.querySelector('.btn-remove-safra').addEventListener('click', () => {
                div.remove();
                updateCalculations();
            });

            const valInput = div.querySelector('.safra-valor');
            if (window.jQuery && window.jQuery.fn.mask) { // Apply mask immediately if using jQuery input creation, but here innerHTML. So do after append or manually.
                // Mask will be applied after append below
            }

            valInput.addEventListener('input', updateCalculations);

            rowsContainer.appendChild(div);

            // --- SMART FILL LOGIC ---
            // Calculate Remaining Balance
            const totalItem = parseFloat(itemTotalInput.value.replace(/\D/g, "")) / 100 || 0;
            let currentSum = 0;

            // Sum existing rows (excluding the one we just added, but simpler to sum all OTHER inputs)
            // Actually, since we just appended, let's sum all except current
            const allInputs = rowsContainer.querySelectorAll('.safra-valor');
            allInputs.forEach(inp => {
                if (inp !== valInput) {
                    currentSum += parseFloat(inp.value.replace(/\D/g, "")) / 100 || 0;
                }
            });

            const remainder = Math.max(0, totalItem - currentSum);

            if (remainder > 0) {
                valInput.value = remainder.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            }
            // ------------------------

            // Mask
            if (window.jQuery && window.jQuery.fn.mask) {
                window.jQuery(div).find('.currency-mask').mask("#.##0,00", { reverse: true });
            }

            updateCalculations();
        };

        // 3. Calculation Logic & Sync
        const updateCalculations = () => {
            const totalItem = parseFloat(itemTotalInput.value.replace(/\D/g, "")) / 100 || 0;
            const safraRows = rowsContainer.querySelectorAll('.item-rateio-row');

            // RULE: Single Child Sync
            // If there is EXACTLY one row, force it to match Total Item (unless Item is 0)
            // This ensures that changing Qtd/Price updates the unique safra apportionment automatically.
            if (safraRows.length === 1 && totalItem > 0) {
                const singleInput = safraRows[0].querySelector('.safra-valor');
                // Check if we should override? Yes, always sync 100% for single row is desired behavior.
                // Only edge case: User explicitly wants to allocate LESS than 100% to a single safra? Rare.
                // We assume 1-to-1 mapping is default.
                singleInput.value = totalItem.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            }

            let sumRateio = 0;

            safraRows.forEach(r => {
                const valInp = r.querySelector('.safra-valor');
                const val = parseFloat(valInp.value.replace(/\D/g, "")) / 100 || 0;
                sumRateio += val;

                const perc = totalItem > 0 ? (val / totalItem) * 100 : 0;
                r.querySelector('.safra-percent').innerText = perc.toFixed(1) + '%';
            });

            // Feedback
            if (feedbackTotal) {
                const diff = Math.abs(totalItem - sumRateio);
                const color = diff < 0.02 ? 'green' : (diff > 0.02 ? '#b45309' : 'green'); // Orange if diff

                // Warning Icon if not matching
                const warning = diff > 0.02 ? '<i class="fas fa-exclamation-circle"></i>' : '<i class="fas fa-check-circle"></i>';

                feedbackTotal.innerHTML = `
                ${warning} Total: <span style="color:${color}">${sumRateio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span> / 
                <span class="target-total">${totalItem.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
            `;
            }
        };
        if (btnAdd) btnAdd.onclick = addItemSafraRow;



        // Listen to Item Total changes
        itemTotalInput.addEventListener('input', updateCalculations);
        itemTotalInput.addEventListener('change', updateCalculations);

        // Initial Check
        checkVisibility();
    },

    // --- AUTO RATEIO LOGIC ---
    calculateAutoRateio: function (container) {
        if (!this.planoContasData) return;

        let total21 = 0;
        const rows = container.querySelectorAll('.item-row');

        if (!rows.length && !container.querySelector('#valor-total-sem-itens')) return;

        // Helper
        const parseInfo = (str) => {
            if (!str) return 0;
            if (str.includes(',')) return parseFloat(str.replace(/\./g, '').replace(',', '.')) || 0;
            return parseFloat(str) || 0;
        };

        if (rows.length > 0) {
            // Mode: Com Itens
            rows.forEach(row => {
                const catInput = row.querySelector('.item-plano-select');
                const totalInput = row.querySelector('.item-total');
                if (catInput && totalInput) {
                    const catVal = catInput.value.trim();
                    const valStr = totalInput.value.replace('R$', '').trim();
                    const val = parseInfo(valStr); // Fixed Parsing
                    if (catVal.startsWith('2.1')) total21 += val;
                }
            });
        } else {
            // Mode: Sem Itens (Simple)
            const catInput = container.querySelector('#categoria-contabil');
            const totalInput = container.querySelector('#valor-total-sem-itens');
            if (catInput && totalInput) {
                const catVal = catInput.value.trim();
                const val = parseInfo(totalInput.value); // Fixed Parsing
                if (catVal.startsWith('2.1')) total21 += val;
            }
        }

        const area = container.querySelector('#area-rateio');
        if (!area) return;

        // Visual Feedback in Header
        const header = area.querySelector('h5');
        if (header) {
            if (total21 > 0) {
                header.innerHTML = `Rateio por Safra <span style="font-weight:normal; font-size:0.9em; color:#d97706; margin-left:10px;">(Necessário: ${total21.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })})</span>`;
            } else {
                header.innerHTML = `Rateio por Safra (Opcional)`;
            }
        }

        // Auto-Fill Logic
        if (total21 > 0) {
            const rateioRows = area.querySelectorAll('.rateio-row');

            // Case 0: No rows -> Create one empty safra, full value
            if (rateioRows.length === 0) {
                const btnAdd = area.querySelector('#btn-add-rateio');
                if (btnAdd) btnAdd.click();

                // Get the new row
                const newRows = area.querySelectorAll('.rateio-row');
                const lastRow = newRows[newRows.length - 1];
                if (lastRow) {
                    const valInput = lastRow.querySelector('.rateio-valor');
                    if (valInput) {
                        valInput.value = total21.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                        valInput.classList.add('input-flash'); // Add CSS class for flash effect if exists, or just valid
                        setTimeout(() => valInput.classList.remove('input-flash'), 1000);
                    }
                }
            }
            // Case 1: Exactly 1 row -> Update value (Assume user is happy with simple split)
            else if (rateioRows.length === 1) {
                const row = rateioRows[0];
                const valInput = row.querySelector('.rateio-valor');
                if (valInput) {
                    valInput.value = total21.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                }
            }
            // Case N: Multiple rows -> Don't touch values
        }
    },

    loadPlanoContasData: async function () {
        if (this.planoContasData && this.planoContasData.length > 0) return;
        const { data } = await window.FazendaRP.supabase
            .from('financeiro_plano_contas')
            .select('codigo, nome, tipo')
            .order('codigo');
        this.planoContasData = data || [];

        // Update datalists
        const dl = document.getElementById('list-plano-contas');
        if (dl) dl.innerHTML = this.getPlanoContasOptionsHTML();
    },

    getPlanoContasOptionsHTML: function () {
        return (this.planoContasData || [])
            .filter(c => c.tipo === 'ANALITICA')
            .map(c => `<option value="${c.codigo} - ${c.nome}">${c.codigo} - ${c.nome}</option>`)
            .join('');
    },

    // ... helpers ...
    getContasOptionsHTML: function () {
        return (this.contasData || []).map(c => `<option value="${c.id}">${c.nome}</option>`).join('');
    },

    getMateriaisOptionsHTML: function () {
        const data = window.FazendaRP.SuprimentosData || [];
        const options = data
            .filter(i => !i.tipo || i.tipo === 'Material' || i.tipo === 'Item' || i.tipo === 'ITEM') // Include Uppercase ITEM
            .map(i => `<option value="${i.nome}">`)
            .join('');

        if (options.length === 0) console.warn("Financeiro: Nenhum option gerado para materiais (Datalist vazio).");
        return options;
    },
    getItemRowHTML: function (itemData = null) {
        // Prepare Unit Value and Discount Attributes
        let vUnitVal = '';
        let discountStyle = 'border: 1px solid #cbd5e1;';
        let discountTitle = '';
        let originalValAttr = '';

        if (itemData) {
            // If item has discount processing
            if (itemData.originalUnit && itemData.netUnit && itemData.originalUnit !== itemData.netUnit) {
                // Formatting for display
                const formattedNet = itemData.netUnit.toLocaleString('pt-BR', { minimumFractionDigits: 4 });
                const formattedOrig = itemData.originalUnit.toLocaleString('pt-BR', { minimumFractionDigits: 4 });
                const formattedDesc = (itemData.originalUnit - itemData.netUnit).toLocaleString('pt-BR', { minimumFractionDigits: 4 });

                vUnitVal = formattedNet;

                // Visual Cues
                discountStyle = 'border: 1px solid #cbd5e1; border-bottom: 3px solid #3b82f6; background-color: #eff6ff;';
                discountTitle = `Preço Original: R$ ${formattedOrig}\nDesconto Rateado: R$ ${formattedDesc}`;
                originalValAttr = `data-original-value="${itemData.originalUnit}"`;
            } else if (itemData.vUnCom) {
                // Just explicit value without discount difference
                vUnitVal = parseFloat(itemData.vUnCom).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
            }
        }

        return `
        <div class="item-wrapper" style="margin-bottom: 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #fff;">
            <div class="item-row" style="display: flex; gap: 10px; align-items: flex-end; padding: 10px; background: #f8fafc; position: relative;">
                <!-- Material -->
                <div style="flex: 3; min-width: 250px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Material / Item</label>
                    <div style="display: flex; gap: 5px;">
                        <div class="custom-dropdown-container" style="position: relative; flex: 1;">
                            <input type="text" class="item-material-search" 
                                   placeholder="Buscar material..." 
                                   autocomplete="off" 
                                   value="${itemData ? (itemData.matchedName || itemData.xProd || '') : ''}" 
                                   title="${itemData && itemData.matchedName ? 'Correspondência automática encontrada. Original: ' + itemData.xProd : ''}"
                                   style="width: 100%; padding: 6px 8px; border: 1px solid ${itemData && itemData.matchedName ? '#10b981' : '#cbd5e1'}; border-left: ${itemData && itemData.matchedName ? '4px solid #10b981' : ''}; border-radius: 4px;">
                            <div class="custom-dropdown-results" style="display:none; position:absolute; top:100%; left:0; width:100%; max-height:250px; overflow-y:auto; background:white; border:1px solid #cbd5e1; border-radius:4px; box-shadow:0 4px 6px -1px rgba(0,0,0,0.1); z-index:9999;"></div>
                        </div>
                        <button type="button" class="btn-quick-add-material" style="background: #10b981; color: white; border: none; border-radius: 4px; width: 32px; height: 32px; cursor: pointer; display: flex; align-items: center; justify-content: center;" title="Cadastrar Novo Item Rapidamente" onclick="window.FazendaRP.Pages.financeiro.handleQuickAddMaterial(this)">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>

            <!-- Machine & Horimeter (Conditional) -->
            <div class="item-machine-area" style="display: none; flex: 2; min-width: 150px; flex-direction: column; gap: 5px;">
                 <div>
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Máquina (Destino)</label>
                    <select class="item-maquina-select" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px; background: white;">
                        <option value="">Selecione...</option>
                    </select>
                 </div>
                 <div>
                    <input type="number" class="item-horimetro" placeholder="Horímetro (Op.)" step="0.1" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px;">
                 </div>
            </div>

                <div style="flex: 2; min-width: 180px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Conta Contábil</label>
                    <select class="item-plano-select" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px; background: white;">
                        <option value="">Selecione...</option>
                        <!-- Populated dynamically via JS -->
                    </select>
                </div>

                <!-- Qtd -->
                <div style="flex: 1.2; min-width: 100px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Qtd</label>
                    <input type="text" class="item-qtd decimal-mask" value="${(itemData ? itemData.qCom : 1).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}" placeholder="0,000" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px;">
                </div>

                <!-- Unid -->
                <div style="flex: 0.8; min-width: 80px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Unid.</label>
                    <select class="item-unid" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px; background: white;">
                         <!-- Will be selected by JS or default -->
                         <option value="${itemData ? itemData.uCom : 'UN'}">${itemData ? itemData.uCom : 'UN'}</option>
                        <option value="UN">UN</option><option value="PC">PC</option><option value="L">L</option><option value="KG">KG</option><option value="SC">SC</option><option value="TON">TON</option><option value="M">M</option><option value="CX">CX</option>
                    </select>
                </div>

                <!-- V. Unit -->
                <div style="flex: 1.2; min-width: 100px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">V. Unit</label>
                    <input type="text" class="item-vunit unit-value-mask" value="${itemData ? parseFloat(itemData.vUnCom).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : ''}" placeholder="0,0000" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px;">
                </div>

                <!-- Desconto -->
                <div style="flex: 0.8; min-width: 80px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Desc. (Un)</label>
                    <input type="text" class="item-desc unit-value-mask" value="${itemData && itemData.unitDiscount > 0 ? parseFloat(itemData.unitDiscount).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : ''}" placeholder="0,0000" style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px; color: #ef4444;">
                </div>

                <!-- Total -->
                <div style="flex: 1.2; min-width: 100px;">
                    <label style="font-size: 0.75rem; color: #64748b; font-weight: 500; display: block; margin-bottom: 4px;">Total</label>
                    <input type="text" class="item-total currency-mask" placeholder="R$ 0,00" readonly style="width: 100%; padding: 6px 8px; border: 1px solid #cbd5e1; border-radius: 4px; background: #e2e8f0;">
                </div>

                <!-- Delete -->
                <div style="padding-bottom: 2px;">
                    <button type="button" class="btn-remove-item" style="color: #ef4444; border: 1px solid #fee2e2; background: #fef2f2; height: 32px; width: 32px; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center;" onclick="this.closest('.item-wrapper').remove();"><i class="fas fa-trash"></i></button>
                </div>
            </div>

            <!-- Rateio Interno (Hidden by default) -->
            <div class="item-rateio-container" style="display: none; background: #fffbeb; border-top: 1px solid #fcd34d; padding: 10px 15px;">
                <h6 style="margin: 0 0 10px 0; color: #b45309; font-size: 0.8rem; display: flex; align-items: center; gap: 5px;">
                    <i class="fas fa-exclamation-triangle"></i> Rateio por Safra (Obrigatório para contas 1.1 e 2.1)
                </h6>
                <div class="item-rateio-rows"></div>
                <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
                    <button type="button" class="btn-add-item-safra" style="font-size: 0.75rem; background: #fef3c7; color: #b45309; border: 1px solid #fcd34d; padding: 4px 8px; border-radius: 4px; cursor:pointer;">
                        + Adicionar Safra
                    </button>
                    <div class="rateio-feedback" style="font-size: 0.8rem; font-weight: bold; color: #b45309;">
                        Total: R$ 0,00 / <span class="target-total">R$ 0,00</span>
                    </div>
                </div>
            </div>
        </div>
         `;
    },

    handleQuickAddMaterial: async function (btn) {
        console.log("Financeiro: handleQuickAddMaterial clicked.");
        try {
            const row = btn.closest('.item-row');
            if (!row) throw new Error("Linha do item não encontrada.");

            const inputName = row.querySelector('.item-material-search');
            if (!inputName) throw new Error("Campo de busca não encontrado.");

            const typedName = inputName.value.trim();

            // Check if Suprimentos Loaded
            if (!window.FazendaRP.SuprimentosData) {
                console.warn("Financeiro: Catálogo de suprimentos não carregado.");
                alert('O catálogo de materiais ainda está carregando. Tente novamente em alguns segundos.');
                return;
            }

            // Logic: Prepare Categories
            const categories = window.FazendaRP.SuprimentosData.filter(x => !x.tipo || x.tipo === 'CATEGORIA' || x.tipo === 'Group');
            const catOptions = categories.map(c => `<option value="${c.id}">${c.nome}</option>`).join('');

            // Logic: Prepare Accounts (Vínculo)
            // Ensure data is loaded
            if (window.FazendaRP.Pages.financeiro && window.FazendaRP.Pages.financeiro.initPlanoContasData) {
                window.FazendaRP.Pages.financeiro.initPlanoContasData();
            }
            const accountsData = window.FazendaRP.Pages.financeiro.planoContasData || [];
            const accountOptions = accountsData.map(c => {
                const isAnalytical = c.tipo === 'CONTA' || c.tipo === 'ANALITICA';
                const prefix = isAnalytical ? '⚪ ' : '⚫ ';
                // Only analytical accounts should be selectable ideally, but we allow all with visual cue
                return `<option value="${c.codigo} - ${c.nome}" ${!isAnalytical ? 'disabled' : ''}>${prefix}${c.codigo} - ${c.nome}</option>`;
            }).join('');

            const modalId = 'modal-quick-add-material';
            // Remove existing
            const existing = document.getElementById(modalId);
            if (existing) existing.remove();

            // Create Modal HTML
            const modal = document.createElement('div');
            modal.id = modalId;
            modal.className = "modal-overlay";
            modal.style.cssText = "position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:9999; display:flex; align-items:center; justify-content:center;";

            modal.innerHTML = `
            <div class="modal-content" style="background:white; width:450px; padding:25px; border-radius:8px; box-shadow:0 10px 25px rgba(0,0,0,0.2);">
                <h3 style="margin-top:0; color:var(--color-primary); display:flex; align-items:center; gap:10px;">
                    <i class="fas fa-box-open"></i> Novo Material
                </h3>
                <p style="font-size:0.9rem; color:#666; margin-bottom:20px;">Cadastre itens simples rapidamente para continuar o lançamento.</p>
                
                <form id="form-quick-add">
                    <div class="form-group" style="margin-bottom:15px;">
                        <label style="display:block; font-size:0.85rem; font-weight:600; color:#374151; margin-bottom:5px;">Nome do Item *</label>
                        <input type="text" id="quick-nome" class="form-control" value="${typedName}" required style="width:100%; padding:10px; border:1px solid #cbd5e1; border-radius:6px; font-size:1rem;">
                    </div>
                    
                    <div style="display:flex; gap:15px; margin-bottom:15px;">
                        <div class="form-group" style="flex:1;">
                            <label style="display:block; font-size:0.85rem; font-weight:600; color:#374151; margin-bottom:5px;">Categoria *</label>
                            <select id="quick-categoria" class="form-control" required style="width:100%; padding:10px; border:1px solid #cbd5e1; border-radius:6px; background:white;">
                                <option value="">Selecione...</option>
                                ${catOptions}
                            </select>
                        </div>
                        <div class="form-group" style="width:120px;">
                            <label style="display:block; font-size:0.85rem; font-weight:600; color:#374151; margin-bottom:5px;">Unidade *</label>
                            <select id="quick-unidade" class="form-control" style="width:100%; padding:10px; border:1px solid #cbd5e1; border-radius:6px; background:white;">
                                 <option value="UN">UN</option>
                                 <option value="L">L</option>
                                 <option value="KG">KG</option>
                                 <option value="SC">SC</option>
                                 <option value="CX">CX</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group" style="margin-bottom:25px;">
                        <label style="display:block; font-size:0.85rem; font-weight:600; color:#374151; margin-bottom:5px;">Conta Contábil Padrão (Vínculo)</label>
                        <select id="quick-conta" class="form-control" style="width:100%; padding:10px; border:1px solid #cbd5e1; border-radius:6px; background:white;">
                             <option value="">-- Nenhuma --</option>
                             ${accountOptions}
                        </select>
                        <small style="color:#9ca3af; font-size:0.8rem;">Isso facilitará os próximos lançamentos deste item.</small>
                    </div>

                    <div style="text-align:right; display:flex; justify-content:flex-end; gap:10px; margin-top:20px; border-top:1px solid #f1f5f9; padding-top:20px;">
                        <button type="button" class="btn" style="background:white; border:1px solid #cbd5e1; color:#64748b; padding:8px 16px; border-radius:6px; cursor:pointer;" onclick="document.getElementById('${modalId}').remove()">Cancelar</button>
                        <button type="submit" class="btn btn-success" style="background:#10b981; color:white; border:none; padding:8px 24px; border-radius:6px; font-weight:600; cursor:pointer; box-shadow:0 2px 4px rgba(16, 185, 129, 0.2);">Salvar Item</button>
                    </div>
                </form>
            </div>
        `;

            document.body.appendChild(modal);

            // Handle Submit
            modal.querySelector('form').addEventListener('submit', async (e) => {
                e.preventDefault();
                const nome = document.getElementById('quick-nome').value;
                const parentId = document.getElementById('quick-categoria').value;
                const unidade = document.getElementById('quick-unidade').value;
                const conta = document.getElementById('quick-conta').value; // Optional
                const btnSubmit = e.target.querySelector('button[type="submit"]');

                btnSubmit.innerText = 'Salvando...';
                btnSubmit.disabled = true;

                try {
                    const payload = {
                        nome: nome,
                        tipo: 'ITEM',
                        parent_id: parentId,
                        unidades: [unidade],
                        status: 'Ativo'
                    };

                    // Add account if selected
                    if (conta) {
                        payload.contas = [conta];
                    }

                    const { data, error } = await window.FazendaRP.supabase
                        .from('suprimentos_itens')
                        .insert([payload])
                        .select()
                        .single();

                    if (error) throw error;

                    // Update Local Cache
                    window.FazendaRP.SuprimentosData.push({
                        id: data.id,
                        nome: data.nome,
                        tipo: 'ITEM',
                        parentId: data.parent_id,
                        unidades: data.unidades,
                        contas: data.contas || [],
                        expanded: false
                    });

                    window.FazendaRP.Toast.show('success', 'Cadastrado', 'Item adicionado com sucesso!');

                    // Update Input with New Name
                    inputName.value = nome;
                    row.querySelector('.item-unid').value = unidade;

                    // --- NEW: Auto-Select Account in Row ---
                    if (conta) {
                        // Find the account select in the row
                        const rowAccountSelect = row.querySelector('.item-plano-select');
                        if (rowAccountSelect) {
                            // Check if option exists (it should, as we used the same source)
                            // But we might need to refresh options? No, options are usually already loaded
                            // Wait, are they?
                            // Ideally we set the value.
                            // But wait, the row's account dropdown options might not be populated if 'setupMaterialDropdown' hasn't triggered yet?
                            // Usually the accounting dropdown is always fully populated in 'lancamentos-form.js'.
                            // Let's try setting it.
                            rowAccountSelect.value = conta;
                            // Fallback check: if value didn't stick, maybe options aren't there?
                            // We can force add it if needed, but standard flow assumes full list.
                        }
                    }

                    // Trigger Input Event to refresh stuff (Calculations etc)
                    inputName.dispatchEvent(new Event('input', { bubbles: true }));

                    modal.remove();

                } catch (err) {
                    console.error(err);
                    alert('Erro ao salvar: ' + err.message);
                    btnSubmit.innerText = 'Salvar Item';
                    btnSubmit.disabled = false;
                }
            });
        } catch (e) {
            console.error("Financeiro: Erro crítico em handleQuickAddMaterial:", e);
            alert("Erro ao abrir janela de material: " + e.message);
        }
    },

    // --- HELPERS ---
    fetchMinhasEmpresas: async function () {
        if (this.cacheMinhasEmpresas) return this.cacheMinhasEmpresas;

        try {
            const { data, error } = await window.FazendaRP.supabase
                .from('empresas')
                .select('cpf_cnpj');

            if (error) throw error;

            this.cacheMinhasEmpresas = (data || []).map(e => e.cpf_cnpj ? e.cpf_cnpj.replace(/\D/g, "") : "").filter(c => c);
            console.log("DEBUG: Minhas Empresas Cache:", this.cacheMinhasEmpresas);
            return this.cacheMinhasEmpresas;
        } catch (e) {
            console.error("Erro ao buscar empresas:", e);
            return []; // Fail safe: logic will likely block if empty, which is safer
        }
    },

    processarXML: function (file, mode) {
        if (!file) return;

        // --- STORE FILE FOR AUTO-ATTACHMENT ---
        window.FazendaRP.TempXMLFile = file;
        console.log("Financeiro: XML file stored for auto-attachment:", file.name);

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const text = e.target.result;
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, "text/xml");

                // Check for parse errors
                const parseError = xmlDoc.getElementsByTagName("parsererror");
                if (parseError.length > 0) {
                    throw new Error("Arquivo XML inválido ou corrompido.");
                }

                // --- SECURITY CHECK (Ownership) ---
                const myDoctos = await this.fetchMinhasEmpresas();

                // Get Documents from XML
                const emit = xmlDoc.getElementsByTagName("emit")[0];
                const dest = xmlDoc.getElementsByTagName("dest")[0];

                let emitDoc = "";
                let destDoc = "";

                if (emit) {
                    emitDoc = emit.getElementsByTagName("CNPJ")[0]?.textContent || emit.getElementsByTagName("CPF")[0]?.textContent || "";
                }
                if (dest) {
                    destDoc = dest.getElementsByTagName("CNPJ")[0]?.textContent || dest.getElementsByTagName("CPF")[0]?.textContent || "";
                }

                const cleanEmit = emitDoc.replace(/\D/g, "");
                const cleanDest = destDoc.replace(/\D/g, "");

                // Logic: Either Emit OR Dest must match one of My Companies
                // If My Companies list is empty (first use), warn but allow? Or Block?
                // User requirement: "Só deve aceitar importar se..." -> Block.
                if (myDoctos.length > 0) {
                    const isMyEmission = myDoctos.includes(cleanEmit);
                    const isMyPurchase = myDoctos.includes(cleanDest);

                    if (!isMyEmission && !isMyPurchase) {
                        throw new Error(`Segurança: Esta nota não pertence a nenhuma empresa cadastrada.\n\nEmissor: ${emitDoc}\nDestinatário: ${destDoc}\n\nCadastre seu CNPJ no módulo 'Sistema > Empresas'.`);
                    }
                } else {
                    console.warn("Segurança XML: Nenhuma empresa cadastrada para validar propriedade da nota.");
                    // Optional: throw new Error("Cadastre suas empresas no sistema antes de importar XML.");
                }


                // Basic Info - SAFE ACCESS
                const ideList = xmlDoc.getElementsByTagName("ide");
                const emitList = xmlDoc.getElementsByTagName("emit"); // Re-get for consistency
                const totalList = xmlDoc.getElementsByTagName("ICMSTot");

                if (ideList.length === 0) throw new Error("Tag <ide> não encontrada.");
                if (emitList.length === 0) throw new Error("Tag <emit> não encontrada.");
                // Some XMLs might not have ICMSTot in the usual place, but standard NFe does.
                // We'll proceed with caution.

                const ide = ideList[0];
                // const emit = emitList[0]; // Already got
                const totalNode = totalList.length > 0 ? totalList[0] : null;

                const dhEmi = ide.getElementsByTagName("dhEmi")[0]?.textContent || ide.getElementsByTagName("dEmi")[0]?.textContent || new Date().toISOString();

                let vNF = "0.00";
                if (totalNode) {
                    vNF = totalNode.getElementsByTagName("vNF")[0]?.textContent || "0.00";
                } else {
                    // Try to find vNF anywhere if ICMSTot is missing
                    const vnfList = xmlDoc.getElementsByTagName("vNF");
                    if (vnfList.length > 0) vNF = vnfList[0].textContent;
                }

                const xNome = emit.getElementsByTagName("xNome")[0]?.textContent || "Desconhecido";
                const natOp = ide.getElementsByTagName("natOp")[0]?.textContent || "Compra";
                const nNF = ide.getElementsByTagName("nNF")[0]?.textContent || "";

                // Issuer Document variable already extracted as 'emitDoc'
                // Re-using it below

                // Format values
                const dateVal = dhEmi.split('T')[0];
                const totalVal = parseFloat(vNF).toLocaleString('pt-BR', { minimumFractionDigits: 2 });

                // Extract Due Date (Deep Search) - RESTORED
                let dueDateVal = dateVal; // Default to Emission
                const dVencNode = xmlDoc.getElementsByTagName('dVenc')[0];
                if (dVencNode && dVencNode.textContent) {
                    dueDateVal = dVencNode.textContent;
                }

                const form = document.getElementById('form-lancamento');

                // AUTO-FILL Fields common to both modes
                // 1. Doc Number
                const docInput = form.querySelector('#num-documento');
                if (docInput) docInput.value = nNF;

                // 1.0 Note Control Total (Validation)
                const totalNotaInput = form.querySelector('#valor-total-nota');
                if (totalNotaInput) {
                    totalNotaInput.value = 'R$ ' + totalVal;
                    // Auto-format on blur usually handles it, but let's set it clean
                }

                // 1.1 Emissao & Vencimento
                const emiInput = form.querySelector('#data-emissao');
                if (emiInput) emiInput.value = dateVal;

                const vencInput = form.querySelector('#data-vencimento');
                if (vencInput) {
                    vencInput.value = dueDateVal;
                    if (dueDateVal !== dateVal) {
                        vencInput.style.backgroundColor = '#ecfdf5'; // Greenish highlight
                        vencInput.title = "Data extraída do XML (Fatura)";
                    }
                }

                // 2. Partner Matching
                if (emitDoc) {
                    const parcSelect = form.querySelector('#parceiro-select');
                    if (parcSelect) {
                        const cleanDoc = emitDoc.replace(/\D/g, "");
                        let found = false;

                        // STRICT MATCH FIRST: Check for exact CNPJ presence
                        // Option format usually: "Name (12345678000199)" or similar
                        // We iterate and clean each option's text to compare

                        console.log(`DEBUG: Attempting to match XML CNPJ: ${cleanDoc}`);

                        for (let i = 0; i < parcSelect.options.length; i++) {
                            const optText = parcSelect.options[i].text;
                            // Extract numbers from option text (potentially containing CNPJ)
                            const cleanOpt = optText.replace(/\D/g, "");

                            // Specific check: Does the option contain the FULL CNPJ?
                            // We use includes but on the cleaning string. 
                            // However, to avoid partial matches (like 123 matching 1234), we should ideally verify length or boundary.
                            // But since CNPJs are 14 digits and unique, a full inclusion of 14 digits is safe.
                            if (cleanOpt.includes(cleanDoc)) {
                                parcSelect.selectedIndex = i;
                                found = true;
                                console.log(`DEBUG: Strict Match Found! Index ${i}: ${optText}`);
                                break;
                            }
                        }

                        // Fallback: Fuzzy Name Match REMOVED to prevent false positives (e.g. "AUTO" matching "AGUILERA AUTO").
                        // if (!found && xNome) { ... }

                        if (!found) {
                            // Store for Manual Add
                            window.FazendaRP.TempXMLPartner = {
                                nome: xNome || "Novo Parceiro",
                                doc: cleanDoc,
                                fantasia: xNome
                            };

                            // Visual feedback on the + button
                            const btnAdd = form.querySelector('#btn-add-novo-parceiro');
                            if (btnAdd) {
                                btnAdd.classList.add('pulse-animation'); // CSS class to be added or just style
                                btnAdd.style.border = '2px solid #f59e0b';
                                btnAdd.title = "Clique para cadastrar este parceiro do XML";
                            }

                            // Warn, but don't select wrong one
                            parcSelect.value = "";
                            window.FazendaRP.Toast.show('warning', 'Parceiro Novo', `O CNPJ ${emitDoc} não foi encontrado. Clique no botão '+' para cadastrá-lo.`);
                        } else {
                            window.FazendaRP.TempXMLPartner = null;
                        }
                    }
                }

                if (mode === 'simple') {
                    // Simple Mode: Description, Date, Total
                    // Switch radio? No, usually already correct or doesn't matter as we fill the inputs.

                    form.querySelector('#desc-sem-itens').value = `NFe: ${xNome} - ${natOp}`;
                    form.querySelector('#data-emissao').value = dateVal;
                    form.querySelector('#valor-total-sem-itens').value = totalVal;

                    window.FazendaRP.Toast.show('success', 'XML Importado', 'Dados básicos preenchidos (Sem Itens).');

                } else if (mode === 'items') {
                    // Detailed Mode
                    // 1. Switch to Com Itens
                    const radioItems = form.querySelector('input[name="modo_lancamento"][value="com_itens"]');
                    if (radioItems) {
                        radioItems.checked = true;
                        radioItems.dispatchEvent(new Event('change')); // Trigger toggle logic
                    }

                    // 2. Set Basic Headers
                    form.querySelector('#data-emissao').value = dateVal;
                    // Description is optional here, maybe set obs?
                    form.querySelector('#obs-lancamento').value = `Importado de NFe: ${xNome} - ${natOp}`;

                    // 3. Clear Items
                    const itemsContainer = document.getElementById('items-container');
                    itemsContainer.innerHTML = '';

                    // 4. Extract Global Discount (vDesc) from ICMSTot OR Billing (fat)
                    let globalDiscount = 0;
                    if (totalNode) {
                        globalDiscount = parseFloat(totalNode.getElementsByTagName("vDesc")[0]?.textContent) || 0;
                    }

                    // Fallback: Check 'cobr' -> 'fat' -> 'vDesc' (Desconto Financeiro / Fatura)
                    if (globalDiscount === 0) {
                        const fatNode = xmlDoc.getElementsByTagName("fat")[0];
                        if (fatNode) {
                            globalDiscount = parseFloat(fatNode.getElementsByTagName("vDesc")[0]?.textContent) || 0;
                            if (globalDiscount > 0) console.log("DEBUG: Found Discount in <fat> tag (Billing):", globalDiscount);
                        }
                    }

                    // 5. Process Items (Collect -> Calculate -> Render)
                    const detNodes = xmlDoc.getElementsByTagName("det");
                    let items = [];
                    let totalProductsValue = 0;

                    // Helper to get float from node
                    const getFloat = (parent, tag) => parseFloat(parent.getElementsByTagName(tag)[0]?.textContent) || 0;

                    // 5.1 Collect Items
                    for (let i = 0; i < detNodes.length; i++) {
                        const prod = detNodes[i].getElementsByTagName("prod")[0];
                        const xProd = prod.getElementsByTagName("xProd")[0]?.textContent;
                        const qCom = parseFloat(prod.getElementsByTagName("qCom")[0]?.textContent);
                        const vUnCom = parseFloat(prod.getElementsByTagName("vUnCom")[0]?.textContent);
                        const vProd = parseFloat(prod.getElementsByTagName("vProd")[0]?.textContent);
                        const uCom = prod.getElementsByTagName("uCom")[0]?.textContent;

                        // Check if item has specific discount (vDesc inside prod)
                        const itemDesc = parseFloat(prod.getElementsByTagName("vDesc")[0]?.textContent) || 0;

                        // --- FUZZY MATCH LOGIC ---
                        let matchedId = null;
                        let matchedName = null;

                        if (window.FazendaRP.SuprimentosData) {
                            const cleanXML = xProd.toLowerCase().trim();

                            // Finds best match based on length (Longer DB name match is usually more specific)
                            // Strategy:
                            // 1. Exact Match
                            // 2. XML contains DB Name (e.g. "MAGMA 500 SC 5L" contains "MAGMA 500 SC")
                            // 3. DB Name contains XML (e.g. "DIESEL" contains "DIESEL")

                            const matches = window.FazendaRP.SuprimentosData.filter(db => {
                                const cleanDB = db.nome.toLowerCase().trim();
                                return cleanXML === cleanDB || cleanXML.includes(cleanDB) || cleanDB.includes(cleanXML);
                            });

                            if (matches.length > 0) {
                                // Sort by length of DB Name descending to prioritize "MAGMA 500 SC" over "MAGMA"
                                matches.sort((a, b) => b.nome.length - a.nome.length);
                                const best = matches[0];
                                matchedId = best.id;
                                matchedName = best.nome;
                                console.log(`DEBUG: Auto-Matched '${xProd}' -> '${best.nome}'`);
                            }
                        }

                        items.push({
                            xProd, qCom, vUnCom, vProd, uCom, itemDesc, matchedId, matchedName
                        });

                        totalProductsValue += vProd;
                    }

                    // 5.2 Calculate Discounts (Proportional if Global exists and Item Specific is zero)
                    // If items have their own vDesc, we respect that sum.
                    // If items have 0 vDesc but Header has vDesc, we distribute.

                    const sumItemDescs = items.reduce((acc, it) => acc + it.itemDesc, 0);
                    let finalItems = [];

                    // FALLBACK 2: Math Check (difference between Items Total and Note Total)
                    // If no explicit discount found, but Items > Note, the diff is an implicit discount.
                    if (globalDiscount < 0.01 && sumItemDescs < 0.01) {
                        const vNFParsed = parseFloat(vNF) || 0; // vNF extracted at start
                        const diff = totalProductsValue - vNFParsed;
                        if (diff > 0.05) { // Tolerance 5 cents
                            console.log(`DEBUG: Implicit Discount Detected (Items ${totalProductsValue} - Note ${vNFParsed} = ${diff})`);
                            globalDiscount = diff;
                        }
                    }

                    // Logic: Use Item Discount if present, otherwise distribute Global
                    if (sumItemDescs > 0.01) {
                        // Case A: Items already have discount. Use it.
                        console.log("DEBUG: Using Item Specific Discounts from XML");
                        finalItems = items.map(it => ({
                            ...it,
                            discountVal: it.itemDesc
                        }));
                    } else if (globalDiscount > 0.01 && totalProductsValue > 0) {
                        // Case B: Global Discount to be distributed
                        console.log(`DEBUG: Distributing Global Discount of ${globalDiscount} over ${totalProductsValue}`);
                        const factor = globalDiscount / totalProductsValue;

                        let distributedSoFar = 0;
                        finalItems = items.map(it => {
                            const share = parseFloat((it.vProd * factor).toFixed(2)); // Truncate to 2 decimals
                            distributedSoFar += share;
                            return { ...it, discountVal: share };
                        });

                        // Cents Correction
                        const diff = globalDiscount - distributedSoFar;
                        if (Math.abs(diff) > 0.001) {
                            // Add diff to the largest item to minimize impact
                            // Find index of largest vProd
                            const maxIdx = finalItems.reduce((maxI, x, i, arr) => x.vProd > arr[maxI].vProd ? i : maxI, 0);
                            finalItems[maxIdx].discountVal += diff;
                            console.log(`DEBUG: Applying rounding diff ${diff.toFixed(2)} to item ${maxIdx}`);
                        }

                    } else {
                        // Case C: No Discount
                        finalItems = items.map(it => ({ ...it, discountVal: 0 }));
                    }


                    // 5.3 Render Items
                    for (let it of finalItems) {
                        // Calculate Net Values
                        // Net Total = Prod Total - Discount
                        const netTotal = it.vProd - it.discountVal;
                        // Net Unit = Net Total / Qty
                        const netUnit = netTotal / it.qCom;

                        // Create Row with Data
                        const tempDiv = document.createElement('div');

                        // Calculate Unit Discount for display/logic
                        // discountVal is the Share of Total Discount for this line (Amount).
                        // User wants "Per Unit".
                        const unitDiscount = it.discountVal / it.qCom;

                        // Pass data to render correct visuals
                        tempDiv.innerHTML = this.getItemRowHTML({
                            xProd: it.xProd,
                            qCom: it.qCom,
                            uCom: it.uCom,
                            vUnCom: it.vUnCom, // Gross Unit
                            originalUnit: it.vUnCom,
                            netUnit: netUnit,
                            discountVal: it.discountVal, // Total Discount Amount (keep for ref)
                            unitDiscount: unitDiscount,   // Unit Discount (for display)
                            matchedId: it.matchedId,      // New Prop
                            matchedName: it.matchedName   // New Prop
                        });

                        const row = tempDiv.firstElementChild; // .item-wrapper
                        itemsContainer.appendChild(row);

                        // Populate Total (Calculated by JS on row add usually, but XML fixes it)
                        // Note: getItemRowHTML renders Unit input. Total input is standard.
                        // We need to set the TOTAL field manually if getItemRowHTML didn't set it (it doesn't set value="..." for total)

                        // Wait, check getItemRowHTML structure... it doesn't return the total input populated?
                        // Let's check line 1420 (not visible in diff but logical).
                        // Actually standard row doesn't have total input VALUE set in HTML.
                        // So we set it here.

                        const totalInput = row.querySelector('.item-total');
                        if (totalInput) totalInput.value = netTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 });

                        // Attempt to match Unit if not in standard list
                        const unitSelect = row.querySelector('.item-unid');
                        let setUnit = false;
                        for (let opt of unitSelect.options) {
                            if (opt.value.toUpperCase() === it.uCom.toUpperCase()) {
                                unitSelect.value = opt.value;
                                setUnit = true;
                                break;
                            }
                        }

                        // Trigger logic setup for this row
                        this.setupMaterialDropdown(row);
                        this.setupItemRateioEvents(row); // New Rateio Logic

                        // Setup Mask for Qtd
                        if (window.jQuery && window.jQuery.fn.mask) {
                            window.jQuery(row).find('.decimal-mask').mask("#.##0,000", { reverse: true });
                        }
                    }


                    // Update Total Label
                    if (typeof this.updateItensTotal === 'function') {
                        this.updateItensTotal(itemsContainer);
                    } else {
                        console.warn("Função updateItensTotal não encontrada.");
                    }
                    window.FazendaRP.Toast.show('success', 'XML Importado', `${finalItems.length} itens (Descontos processados).`);
                }

            } catch (err) {
                console.error("Erro parsing XML:", err);
                window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao ler o arquivo XML.');
            }
        };
        reader.readAsText(file);
    },

    updateAllMaquinasSelects: function (container) { },
    gerarParcelas: function (container) {
        const totalInput = container.querySelector('#valor-total-sem-itens');
        // Check mode: if 'com_itens', sum items
        const isComItens = container.querySelector('input[name="modo_lancamento"][value="com_itens"]').checked;
        let valTotal = 0;

        // Helper to parse currency robustly
        const parseCurrency = (str) => {
            if (!str) return 0;
            // If contains comma, assume standard BR mask (1.000,00)
            if (str.includes(',')) {
                return parseFloat(str.replace(/\./g, '').replace(',', '.')) || 0;
            }
            // If no comma, assume simple integer/float
            return parseFloat(str) || 0;
        };

        if (isComItens) {
            // Sum items
            container.querySelectorAll('.item-total').forEach(inp => {
                const valStr = inp.value.replace('R$', '').trim();
                valTotal += parseCurrency(valStr);
            });
        } else {
            // Fix: Don't assume strict mask "000". Use robust parsing.
            valTotal = parseCurrency(totalInput.value);
        }

        const num = parseInt(container.querySelector('#num-parcelas').value) || 1;
        const tbody = container.querySelector('#tabela-parcelas tbody');
        tbody.innerHTML = '';

        // Safe division
        let valParc = valTotal / num;
        // Adjust precision to 2 decimals to avoid floating point generic issues, then distribute remainder
        valParc = Math.floor(valParc * 100) / 100;
        let remainder = valTotal - (valParc * num);

        let venc = new Date(container.querySelector('#data-vencimento').value);

        for (let i = 0; i < num; i++) {
            const tr = document.createElement('tr');
            const d = new Date(venc);
            d.setMonth(d.getMonth() + i);

            // Distribute penny remainder to first installments
            let currentVal = valParc;
            if (remainder > 0.009) {
                currentVal += 0.01;
                remainder -= 0.01;
            }

            tr.innerHTML = `
                <td>${i + 1}</td>
                <td><input type="date" value="${d.toISOString().split('T')[0]}" style="width:100%"></td>
                <td><input type="text" class="currency-mask" value="${currentVal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}" style="width:100%"></td>
            `;
            tbody.appendChild(tr);
        }

        // Update Total Display Function
        const updateTotalDisplay = () => {
            let sum = 0;
            tbody.querySelectorAll('.currency-mask').forEach(inp => {
                sum += parseCurrency(inp.value);
            });
            const totalDisp = container.querySelector('#total-parcelado-display');
            if (totalDisp) {
                totalDisp.innerText = sum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                // Warning if mismatch
                if (Math.abs(sum - valTotal) > 0.02) totalDisp.style.color = 'red';
                else totalDisp.style.color = '#0f766e';
            }
        };

        // Attach Listeners
        tbody.addEventListener('input', (e) => {
            if (e.target.classList.contains('currency-mask')) updateTotalDisplay();
        });

        updateTotalDisplay();

        // Re-apply masks to new inputs
        if (window.jQuery && window.jQuery.fn.mask) {
            window.jQuery(tbody).find('.currency-mask').mask("#.##0,00", { reverse: true });
        }
    },

    uploadFiles: async function (fileList) {
        if (!fileList || fileList.length === 0) return;

        const container = document.getElementById('lista-anexos');
        if (!container) return;

        // Initialize state if null
        if (!this.currentAttachments) this.currentAttachments = [];

        // Convert FileList to Array
        const files = Array.from(fileList);
        const bucket = 'comprovantes';

        for (const file of files) {
            // UI Item (Uploading...)
            const div = document.createElement('div');
            div.className = 'anexo-item';
            div.style.cssText = "display: flex; align-items: center; justify-content: space-between; background: #fff; padding: 10px; border: 1px solid #eee; border-radius: 6px; font-size: 0.9rem;";
            div.innerHTML = `
                <div style="display:flex; align-items:center; gap:10px;">
                    <i class="fas fa-spinner fa-spin" style="color:var(--color-primary)"></i>
                    <span>${file.name}</span>
                </div>
                <small style="color:#666">${(file.size / 1024).toFixed(1)} KB</small>
            `;
            container.appendChild(div);

            try {
                // Unique Name: timestamp_filename
                // Sanitize filename to avoid weird characters issues
                const sanitizedName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
                const ext = sanitizedName.split('.').pop();
                const path = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}.${ext}`;

                const { data, error } = await window.FazendaRP.supabase.storage
                    .from(bucket)
                    .upload(path, file);

                if (error) throw error;

                // Get Public URL
                const { data: publicData } = window.FazendaRP.supabase.storage
                    .from(bucket)
                    .getPublicUrl(path);

                const publicUrl = publicData.publicUrl;

                // Success UI
                div.innerHTML = `
                    <div style="display:flex; align-items:center; gap:10px;">
                        <i class="fas fa-check-circle" style="color:green"></i>
                        <a href="${publicUrl}" target="_blank" style="text-decoration:none; color:#333; font-weight:500;">${file.name}</a>
                    </div>
                     <button type="button" class="btn-remove-anexo" style="border:none; background:none; color:red; cursor:pointer;"><i class="fas fa-times"></i></button>
                `;

                // Add to State
                // Store object: { name, url, path, type }
                const attachObj = {
                    name: file.name,
                    url: publicUrl,
                    path: path,
                    type: file.type
                };
                this.currentAttachments.push(attachObj);

                // Remove logic
                div.querySelector('.btn-remove-anexo').onclick = () => {
                    // Start remove process (Visual + State + Optional Storage delete)
                    this.currentAttachments = this.currentAttachments.filter(a => a.path !== path);
                    div.remove();
                };

            } catch (err) {
                console.error(err);

                // Feedback visual de erro
                div.style.background = '#fef2f2';
                div.style.border = '1px solid #fca5a5';
                div.innerHTML = `
                    <div style="display:flex; align-items:center; gap:10px; color:#b91c1c;">
                        <i class="fas fa-exclamation-triangle"></i>
                        <span>Erro: ${file.name}</span>
                    </div>
                    <div style="font-size:0.8em; color:#666; margin-left:25px;">${err.message || 'Falha no upload'}</div>
                `;

                window.FazendaRP.Toast.show('error', 'Erro no Upload', `Falha ao enviar ${file.name}: ${err.message}`);
            }
        }
    },

    loadContasData: async function () {
        const { data } = await window.FazendaRP.supabase.from('financeiro_contas').select('*').eq('ativa', true);
        this.contasData = data || [];
        this.loadPlanoContasData(); // Trigger Load Plano Code too
    },

    loadSuprimentosData: async function () {
        console.log("Financeiro: Carregando dados de suprimentos...");
        const { data, error } = await window.FazendaRP.supabase
            .from('suprimentos')
            .select('*')
            .neq('status', 'Inativo')
            .order('nome');

        if (error) {
            console.error("Financeiro: Erro ao carregar suprimentos:", error);
            window.FazendaRP.SuprimentosData = [];
        } else {
            window.FazendaRP.SuprimentosData = data || [];
            console.log(`Financeiro: ${window.FazendaRP.SuprimentosData.length} suprimentos carregados.`);
        }
    },

    updateParceirosSelect: async function (doc) {
        const { data } = await window.FazendaRP.supabase.from('parceiros').select('id, nome').order('nome');
        const s = doc.getElementById('parceiro-select');
        if (s && data) {
            const current = s.value;
            while (s.options.length > 1) s.remove(1);
            data.forEach(p => {
                const o = document.createElement('option');
                o.value = p.id; o.text = p.nome;
                s.add(o);
            });
            s.value = current;
        }
    }

});
